/* Adirena — DOM overrides for Smooche-match buy box */
(function () {
  'use strict';

  var AVATARS_HTML =
    '<div class="adirena-social-proof">' +
      '<div class="adirena-social-proof__avatars">' +
        '<img src="https://i.pravatar.cc/80?img=44" alt="" loading="lazy" width="28" height="28">' +
        '<img src="https://i.pravatar.cc/80?img=49" alt="" loading="lazy" width="28" height="28">' +
        '<img src="https://i.pravatar.cc/80?img=47" alt="" loading="lazy" width="28" height="28">' +
      '</div>' +
      '<div class="adirena-social-proof__text">' +
        '<strong>Casey</strong>' +
        '<svg class="adirena-social-proof__verified" viewBox="0 0 22 22" aria-hidden="true">' +
          '<path fill="#1DA1F2" d="M22 11l-2.2-2.5.3-3.3-3.3-.7L15.1.7 12 2.05 8.9.7 7.2 3.5l-3.3.7.3 3.3L2 11l2.2 2.5-.3 3.3 3.3.7 1.7 2.8L12 19.95l3.1 1.35 1.7-2.8 3.3-.7-.3-3.3z"/>' +
          '<path fill="#fff" d="m10.05 14.7-3.4-3.4 1.4-1.4 2 2 4.6-4.6 1.4 1.4z"/>' +
        '</svg>' +
        '<span>and 1,000+ women love it</span>' +
      '</div>' +
    '</div>';

  var STAR_SVG =
    '<svg viewBox="0 0 24 24" aria-hidden="true">' +
      '<path fill="currentColor" d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>' +
    '</svg>';

  var STARS_HTML =
    '<div class="adirena-stars-row">' +
      '<span class="adirena-stars-row__stars">' + STAR_SVG.repeat(5) + '</span>' +
      '<span class="adirena-stars-row__text">4.7/5</span>' +
    '</div>';

  /* BOGO selector — product-aware config keyed by handle.
     'shaded' = multi-variant with skin-tone pills (e.g. Second Skin — Serum Tint).
     'single' = single-SKU, Buy 1 / Buy 1 Get 1 Free, no pills (bubble masks, Cover Cream). */
  var PRODUCTS = {
    /* Cleo - The Cutest Cat Ear Hat (cleo-cat-ear-hat, development PDP, product DRAFT, 2026-10-25). Zebra shape:
       one option (Color x 9; five added 2026-10-26 on Surya's selection 'Add all five'), flat variantIds, BOGO pre-selected, no b2g3, no size keys. Hexes = the ONE probe table
       (visuals/cat-ear-plush-hat/pdp-draft/source/hex-probes/hex-probes.md; Leopard = pooled ground patches; the five added
       colourways = that file's § Five added colourways).
       INSERTED FIRST in the map on purpose: the last entry carries no trailing comma, so appending would modify an
       existing line and fail check-additive-js.sh. Do not move this entry to the bottom. */
    "cleo-cat-ear-hat": {
      "type": "shaded",
      "singleTitle": "Buy 1",
      "shadeHeader": "Color",
      "defaultShade": "Leopard",
      "b2g3": false,
      "defaultOffer": "bogo",
      "unitLabel": "Hat",
      "shades": [
        {
          "name": "Leopard",
          "hex": "#483025"
        },
        {
          "name": "Black",
          "hex": "#0E1316"
        },
        {
          "name": "Apricot",
          "hex": "#C9B8A4"
        },
        {
          "name": "White",
          "hex": "#D7D0C5"
        },
        {
          "name": "Small Leopard",
          "hex": "#362419"
        },
        {
          "name": "Khaki Leopard",
          "hex": "#958173"
        },
        {
          "name": "Black-White Leopard",
          "hex": "#ACAEA9"
        },
        {
          "name": "Coffee",
          "hex": "#48382A"
        },
        {
          "name": "Gray",
          "hex": "#A5A2A1"
        }
      ],
      "variantIds": {
        "Leopard": 57891003334839,
        "Black": 57891003367607,
        "Apricot": 57891003400375,
        "White": 57891003433143,
        "Small Leopard": 57898364371127,
        "Khaki Leopard": 57898364403895,
        "Black-White Leopard": 57898364436663,
        "Coffee": 57898364469431,
        "Gray": 57898364502199
      }
    },
    "aspen-platform-slippers": {
  type: "shaded",
  "defaultOffer": "single",
  "singleTitle": "1 Pair",
  "shadeHeader": "Color",
  "defaultShade": "Leopard",
  "unitLabel": "Pair",
  "shades": [
    {
      "name": "Chestnut",
      "hex": "#C0906D"
    },
    {
      "name": "Sand",
      "hex": "#AE9B8C"
    },
    {
      "name": "Grey",
      "hex": "#78777A"
    },
    {
      "name": "Black",
      "hex": "#06070A"
    },
    {"name": "Leopard", "hex": "#B18A54"},
    {"name": "Walnut", "hex": "#796858"},
    {"name": "Mustard Blue Stripes", "hex": "#C1AD7D"},
    {"name": "Olive Green", "hex": "#777A62"},
    {"name":"Mustard","hex":"#816B4A"},
    {"name":"Chocolate","hex":"#4D3533"},
    {"name":"Teddy Cream","hex":"#DACFC7"},
    {"name":"Teddy Chestnut","hex":"#AD735D"},
    {"name":"Chestnut Brown","hex":"#826348"},
    {"name":"Olive Green (Tan Sole)","hex":"#8B7E6C"}
  ],
  sizeHeader: "Size",
  sizeOptionLabel: "US Women",
  sizes: [
    "4",
    "5",
    "6",
    "7",
    "8",
    "9"
  ],
  defaultSize: "",
  "variantIds": {
    "Chestnut": {
      "4": 49227251613879,
      "5": 49227273601207,
      "6": 49227273633975,
      "7": 49227273666743,
      "8": 49227273699511,
      "9": 49227273732279
    },
    "Sand": {
      "4": 49227273765047,
      "5": 49227273797815,
      "6": 49227273830583,
      "7": 49227273863351,
      "8": 49227273896119,
      "9": 49227273928887
    },
    "Grey": {
      "4": 49227273961655,
      "5": 49227273994423,
      "6": 49227274027191,
      "7": 49227274059959,
      "8": 49227274092727,
      "9": 49227274125495
    },
    "Black": {
      "4": 49227274158263,
      "5": 49227274191031,
      "6": 49227274223799,
      "7": 49227274256567,
      "8": 49227274289335,
      "9": 49227274322103
    },
    "Leopard": {"4": 49233847058615, "5": 49233847091383, "6": 49233847124151, "7": 49233847156919, "8": 49233847189687, "9": 49233847222455},
    "Walnut": {"4": 49233847255223, "5": 49233847287991, "6": 49233847320759, "7": 49233847353527, "8": 49233847386295, "9": 49233847419063},
    "Mustard Blue Stripes": {"4": 49233847451831, "5": 49233847484599, "6": 49233847517367, "7": 49233847550135, "8": 49233847582903, "9": 49233847615671},
    "Olive Green": {"4": 49233847648439, "5": 49233847681207, "6": 49233847713975, "7": 49233847746743, "8": 49233847779511, "9": 49233847812279}
  },
  "soles": ["Thick","Thin"],
  "defaultSole": "Thin",
  "soleVariantIds": {"Chestnut":{"Thick":{"4":49227251613879,"5":49227273601207,"6":49227273633975,"7":49227273666743,"8":49227273699511,"9":49227273732279},"Thin":{"4":49239654138039,"5":49239654170807,"6":49239654203575,"7":49239654236343,"8":49239654269111,"9":49239654301879}},"Sand":{"Thick":{"4":49227273765047,"5":49227273797815,"6":49227273830583,"7":49227273863351,"8":49227273896119,"9":49227273928887},"Thin":{"4":49239654924471,"5":49239654957239,"6":49239654990007,"7":49239655022775,"8":49239655055543,"9":49239655088311}},"Grey":{"Thick":{"4":49227273961655,"5":49227273994423,"6":49227274027191,"7":49227274059959,"8":49227274092727,"9":49227274125495},"Thin":{"4":49239655317687,"5":49239655350455,"6":49239655383223,"7":49239655415991,"8":49239655448759,"9":49239655481527}},"Black":{"Thick":{"4":49227274158263,"5":49227274191031,"6":49227274223799,"7":49227274256567,"8":49227274289335,"9":49227274322103},"Thin":{"4":49239654531255,"5":49239654564023,"6":49239654596791,"7":49239654629559,"8":49239654662327,"9":49239654695095}},"Leopard":{"Thick":{"4":49233847058615,"5":49233847091383,"6":49233847124151,"7":49233847156919,"8":49233847189687,"9":49233847222455},"Thin":{"4":49242691895479,"5":49242691928247,"6":49242691961015,"7":49242691993783,"8":49242692026551,"9":49242692059319}},"Walnut":{"Thick":{"4":49233847255223,"5":49233847287991,"6":49233847320759,"7":49233847353527,"8":49233847386295,"9":49233847419063},"Thin":{"4":49239654727863,"5":49239654760631,"6":49239654793399,"7":49239654826167,"8":49239654858935,"9":49239654891703}},"Mustard Blue Stripes":{"Thick":{"4":49233847451831,"5":49233847484599,"6":49233847517367,"7":49233847550135,"8":49233847582903,"9":49233847615671},"Thin":{"4":49242692092087,"5":49242692124855,"6":49242692157623,"7":49242692190391,"8":49242692223159,"9":49242692255927}},"Olive Green":{"Thick":{"4":49233847648439,"5":49233847681207,"6":49233847713975,"7":49233847746743,"8":49233847779511,"9":49233847812279},"Thin":{"4":49242692288695,"5":49242692321463,"6":49242692354231,"7":49242692386999,"8":49242692419767,"9":49242692452535}},"Mustard":{"Thin":{"4":49239654334647,"5":49239654367415,"6":49239654400183,"7":49239654432951,"8":49239654465719,"9":49239654498487},"Thick":{"4":49242692485303,"5":49242692518071,"6":49242692550839,"7":49242692583607,"8":49242692616375,"9":49242692649143}},"Chocolate":{"Thin":{"4":49239655121079,"5":49239655153847,"6":49239655186615,"7":49239655219383,"8":49239655252151,"9":49239655284919},"Thick":{"4":49242692681911,"5":49242692714679,"6":49242692747447,"7":49242692780215,"8":49242692812983,"9":49242692845751}},"Teddy Cream":{"Thin":{"4":49239655514295,"5":49239655547063,"6":49239655579831,"7":49239655612599,"8":49239655645367,"9":49239655678135},"Thick":{"4":49242692878519,"5":49242692911287,"6":49242692944055,"7":49242692976823,"8":49242693009591,"9":49242693042359}},"Teddy Chestnut":{"Thin":{"4":49239655710903,"5":49239655743671,"6":49239655776439,"7":49239655809207,"8":49239655841975,"9":49239655874743},"Thick":{"4":49242693075127,"5":49242693107895,"6":49242693140663,"7":49242693173431,"8":49242693206199,"9":49242693238967}},"Chestnut Brown":{"Thin":{"4":49239655907511,"5":49239655940279,"6":49239655973047,"7":49239656005815,"8":49239656038583,"9":49239656071351},"Thick":{"4":49242693271735,"5":49242693304503,"6":49242693337271,"7":49242693370039,"8":49242693402807,"9":49242693435575}},"Olive Green (Tan Sole)":{"Thin":{"4":49239656104119,"5":49239656136887,"6":49239656169655,"7":49239656202423,"8":49239656235191,"9":49239656267959},"Thick":{"4":49242693468343,"5":49242693501111,"6":49242693533879,"7":49242693566647,"8":49242693599415,"9":49242693632183}}},
  "soleVariantAvailability": {"49227251613879":true,"49227273601207":true,"49227273633975":true,"49227273666743":true,"49227273699511":true,"49227273732279":true,"49227273765047":true,"49227273797815":true,"49227273830583":true,"49227273863351":true,"49227273896119":true,"49227273928887":true,"49227273961655":true,"49227273994423":true,"49227274027191":true,"49227274059959":true,"49227274092727":true,"49227274125495":true,"49227274158263":true,"49227274191031":true,"49227274223799":true,"49227274256567":true,"49227274289335":true,"49227274322103":true,"49233847058615":false,"49233847091383":false,"49233847124151":false,"49233847156919":false,"49233847189687":false,"49233847222455":false,"49233847255223":true,"49233847287991":true,"49233847320759":true,"49233847353527":true,"49233847386295":true,"49233847419063":true,"49233847451831":true,"49233847484599":true,"49233847517367":true,"49233847550135":true,"49233847582903":true,"49233847615671":true,"49233847648439":true,"49233847681207":true,"49233847713975":true,"49233847746743":true,"49233847779511":true,"49233847812279":true,"49239654138039":true,"49239654170807":true,"49239654203575":true,"49239654236343":true,"49239654269111":true,"49239654301879":true,"49239654334647":true,"49239654367415":true,"49239654400183":true,"49239654432951":true,"49239654465719":true,"49239654498487":true,"49239654531255":true,"49239654564023":true,"49239654596791":true,"49239654629559":true,"49239654662327":true,"49239654695095":true,"49239654727863":true,"49239654760631":true,"49239654793399":true,"49239654826167":true,"49239654858935":true,"49239654891703":true,"49239654924471":true,"49239654957239":true,"49239654990007":true,"49239655022775":true,"49239655055543":true,"49239655088311":true,"49239655121079":true,"49239655153847":true,"49239655186615":true,"49239655219383":true,"49239655252151":true,"49239655284919":true,"49239655317687":true,"49239655350455":true,"49239655383223":true,"49239655415991":true,"49239655448759":true,"49239655481527":true,"49239655514295":true,"49239655547063":true,"49239655579831":true,"49239655612599":true,"49239655645367":true,"49239655678135":true,"49239655710903":true,"49239655743671":true,"49239655776439":true,"49239655809207":true,"49239655841975":true,"49239655874743":true,"49239655907511":true,"49239655940279":true,"49239655973047":true,"49239656005815":true,"49239656038583":true,"49239656071351":true,"49239656104119":true,"49239656136887":true,"49239656169655":true,"49239656202423":true,"49239656235191":true,"49239656267959":true,"49242691895479":true,"49242691928247":true,"49242691961015":true,"49242691993783":true,"49242692026551":true,"49242692059319":true,"49242692092087":true,"49242692124855":true,"49242692157623":true,"49242692190391":true,"49242692223159":true,"49242692255927":true,"49242692288695":true,"49242692321463":true,"49242692354231":true,"49242692386999":true,"49242692419767":true,"49242692452535":true,"49242692485303":true,"49242692518071":true,"49242692550839":true,"49242692583607":true,"49242692616375":true,"49242692649143":true,"49242692681911":true,"49242692714679":true,"49242692747447":true,"49242692780215":true,"49242692812983":true,"49242692845751":true,"49242692878519":true,"49242692911287":true,"49242692944055":true,"49242692976823":true,"49242693009591":true,"49242693042359":true,"49242693075127":true,"49242693107895":true,"49242693140663":true,"49242693173431":true,"49242693206199":true,"49242693238967":true,"49242693271735":true,"49242693304503":true,"49242693337271":true,"49242693370039":true,"49242693402807":true,"49242693435575":true,"49242693468343":true,"49242693501111":true,"49242693533879":true,"49242693566647":true,"49242693599415":true,"49242693632183":true},
  reviewProofMode: "existing"
},
    // First entry preserves the existing map trailing-comma contract.
    "low-sole-fuzzy-collar-slippers": {
  type: "shaded",
  singleTitle: "1 Pair",
  shadeHeader: "Color",
  defaultShade: "Chestnut",
  unitLabel: "Pair",
  shades: [
    {
      name: "Chestnut",
      hex: "#A97043"
    },
    {
      name: "Coffee",
      hex: "#6A4F3F"
    },
    {
      name: "Black",
      hex: "#0C0C0B"
    },
    {
      name: "Blush Pink",
      hex: "#BA8488"
    },
    {
      name: "Khaki",
      hex: "#C1A794"
    }
  ],
  sizeHeader: "Size",
  sizeOptionLabel: "US Women",
  sizes: [
    "4-5",
    "6-7",
    "8-9",
    "10-11",
    "12-13"
  ],
  defaultSize: "",
  variantIds: {
    Chestnut: {
      "4-5": 49214240489655,
      "6-7": 49214244290743,
      "8-9": 49214244323511,
      "10-11": 49214244356279,
      "12-13": 49214244389047
    },
    Coffee: {
      "4-5": 49214244421815,
      "6-7": 49214244454583,
      "8-9": 49214244487351,
      "10-11": 49214244520119,
      "12-13": 49214244552887
    },
    Black: {
      "4-5": 49214244585655,
      "6-7": 49214244618423,
      "8-9": 49214244651191,
      "10-11": 49214244683959,
      "12-13": 49214244716727
    },
    "Blush Pink": {
      "4-5": 49214244749495,
      "6-7": 49214244782263,
      "8-9": 49214244815031
    },
    Khaki: {
      "4-5": 49241012666551,
      "6-7": 49241012699319,
      "8-9": 49241012732087
    }
  },
  reviewProofMode: "existing"
},
    /* mosaic-everyday-watch-band — spliced at phase 7 (adirena-pdp-draft), 2026-09-15.
       45 shades in the LIVE Color option order, 5 fits, 187 live variant ids
       (re-read from the store at splice time). PENDING: every `hex` is null until the
       image pack's hex-probe table exists; `defaultShade` is a PROPOSED merchandising
       call (Kalodata 2026-09-15), not a ruled one.
           RE-SPLICED 2026-09-16 (publish-prep): sizeHeader 'Size' -> 'Watch fit' only.
           Base bytes unchanged — the pre-push superset-rebase onto live is still OPEN. */
    'mosaic-everyday-watch-band': {
      type: 'shaded',
      /* Required: the engine interpolates cfg.singleTitle RAW (no || fallback,
         unlike unitLabel) — omit it and the offer title row renders 'undefined'. */
      singleTitle: 'Buy 1 Band',
      shadeHeader: 'Color',
      /* PROPOSED, not ruled — see header. */
      defaultShade: 'Tortoiseshell',
      /* No b2g3 key: this SKU has no second tier (card 1218483894631816 §3, explicit). */
      defaultOffer: 'bogo',
      unitLabel: 'Band',
      /* Closed control reads 'Watch fit' (ruling 2026-09-16, measured-house-source law).
         MEASURED, not authored: the live master serves 'Watch fit' at RUNTIME through two
         independent surfaces — assets/adirena-overrides.js:1121
         (`PRODUCTS['metal-resin-watch-band'].sizeHeader = 'Watch fit'`, the 2026-09-10
         post-object patch) and snippets/mrb-sizing.liquid's labelWatchControls(), which
         rewrites the placeholder option and the aria-label to the same two words.
         This field is read TWICE by the runtime: SIZE_HEADER (the aria-label) and
         SIZE_PLACEHOLDER = SIZE_HEADER (adirena-overrides.js:1297 and :1324), so it is the
         VISIBLE closed-control text as well as the assistive one.
         Mosaic declares it inline rather than patching after the object, so the buy-box gate
         reads the shape the customer actually gets (the master's patch is invisible to
         `_js_config_object`, which slices only the first literal — parity audit D4).
         SUPERSEDES the 'Size' pin for THIS handle. The 2026-09-04 founder ruling ("closed
         size control reads Size, scale stays on the options") still governs every SKU whose
         second option is a SIZE; Mosaic's second option is a watch FIT, and "Watch fit" is
         the store's own option name on this product (shopify-gids.json:
         product.options."Watch fit" = gid://shopify/ProductOption/11506008588471).
         pdp_buybox_contract.SIZED_BUYBOX_CONTRACTS["mosaic-everyday-watch-band"]
         ["placeholder"] moves WITH this field — the gate compares them exactly. */
      sizeHeader: 'Watch fit',
      /* EMPTY prefix, deliberate: the fit values below are self-contained, so the
         engine's null-aware fallback (2026-09-07) renders them bare. */
      sizeOptionLabel: '',
      /* Fail-closed: '' is not a member of `sizes`, so DEFAULT_SIZE resolves to ''
         and the control opens on its placeholder with nothing preselected. */
      defaultSize: '',
      sizes: [
        'Small (38–42mm)',
        'Large (44–49mm)',
        '18 mm',
        '20 mm',
        '22 mm'
      ],
      /* 45 colorways in the store's live Color option order (Tortoiseshell first). */
      shades: [
        { name: 'Tortoiseshell', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Rainbow', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Opal White', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Leopard', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Smoky Tortoise', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Forest Tortoise', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Cow Print', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Nougat', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Chocolate', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Pearl White', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'White', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Ivory Shimmer', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Champagne Silk', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Lilac Pearl', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Powder Pink', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Blush Pearl', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Petal Pink', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Silk Pink', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Mermaid Pink', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Aurora Pink', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Rose & Mint', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Strawberry', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Fuchsia', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Sunset', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Black Coral', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Plum Blossom', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Merlot', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Ink Violet', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Porcelain Blue', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Periwinkle', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Galaxy Blue', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Midnight Bloom', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Pastel Sky', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Moonlight', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Ice Blue', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Cornflower', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Emerald', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Sea Glass', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Peach & Sage', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Jade', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Black', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Black Marble', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Candy Swirl', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Amber', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ },
        { name: 'Clear', hex: null /* PENDING: pack hex-probe table is the ONE instrument */ }
      ],
      /* 187 cells. The 38 colorways without an 18 mm row simply have no 18 mm key —
         that fit exists in exactly 7 colorways (frozen supplier matrix). All seven
         18 mm variants are inventory-tracked / DENY / qty 0: visible, unpurchasable. */
      variantIds: {
        'Tortoiseshell': {
          'Small (38–42mm)': 49185761984695,
          'Large (44–49mm)': 49185767817399,
          '18 mm': 49185767719095,
          '20 mm': 49185767751863,
          '22 mm': 49185767784631
        },
        'Rainbow': {
          'Small (38–42mm)': 49185765261495,
          'Large (44–49mm)': 49185765294263,
          '18 mm': 49185765163191,
          '20 mm': 49185765195959,
          '22 mm': 49185765228727
        },
        'Opal White': {
          'Small (38–42mm)': 49185764704439,
          'Large (44–49mm)': 49185764737207,
          '20 mm': 49185764638903,
          '22 mm': 49185764671671
        },
        'Leopard': {
          'Small (38–42mm)': 49185779646647,
          'Large (44–49mm)': 49185779679415,
          '20 mm': 49185779581111,
          '22 mm': 49185779613879
        },
        'Smoky Tortoise': {
          'Small (38–42mm)': 49185778794679,
          'Large (44–49mm)': 49185778827447,
          '20 mm': 49185778729143,
          '22 mm': 49185778761911
        },
        'Forest Tortoise': {
          'Small (38–42mm)': 49185779515575,
          'Large (44–49mm)': 49185779548343,
          '18 mm': 49185779417271,
          '20 mm': 49185779450039,
          '22 mm': 49185779482807
        },
        'Cow Print': {
          'Small (38–42mm)': 49185764835511,
          'Large (44–49mm)': 49185764868279,
          '20 mm': 49185764769975,
          '22 mm': 49185764802743
        },
        'Nougat': {
          'Small (38–42mm)': 49185767653559,
          'Large (44–49mm)': 49185767686327,
          '18 mm': 49185767555255,
          '20 mm': 49185767588023,
          '22 mm': 49185767620791
        },
        'Chocolate': {
          'Small (38–42mm)': 49185764966583,
          'Large (44–49mm)': 49185764999351,
          '20 mm': 49185764901047,
          '22 mm': 49185764933815
        },
        'Pearl White': {
          'Small (38–42mm)': 49185767948471,
          'Large (44–49mm)': 49185767981239,
          '18 mm': 49185767850167,
          '20 mm': 49185767882935,
          '22 mm': 49185767915703
        },
        'White': {
          'Small (38–42mm)': 49185768210615,
          'Large (44–49mm)': 49185768243383,
          '20 mm': 49185768145079,
          '22 mm': 49185768177847
        },
        'Ivory Shimmer': {
          'Small (38–42mm)': 49185779089591,
          'Large (44–49mm)': 49185779122359,
          '18 mm': 49185778991287,
          '20 mm': 49185779024055,
          '22 mm': 49185779056823
        },
        'Champagne Silk': {
          'Small (38–42mm)': 49185763918007,
          'Large (44–49mm)': 49185763950775,
          '20 mm': 49185763852471,
          '22 mm': 49185763885239
        },
        'Lilac Pearl': {
          'Small (38–42mm)': 49185781907639,
          'Large (44–49mm)': 49185781940407,
          '20 mm': 49185781842103,
          '22 mm': 49185781874871
        },
        'Powder Pink': {
          'Small (38–42mm)': 49185768079543,
          'Large (44–49mm)': 49185768112311,
          '20 mm': 49185768014007,
          '22 mm': 49185768046775
        },
        'Blush Pearl': {
          'Small (38–42mm)': 49185778401463,
          'Large (44–49mm)': 49185778434231,
          '18 mm': 49185778303159,
          '20 mm': 49185778335927,
          '22 mm': 49185778368695
        },
        'Petal Pink': {
          'Small (38–42mm)': 49185781383351,
          'Large (44–49mm)': 49185781416119,
          '20 mm': 49185781317815,
          '22 mm': 49185781350583
        },
        'Silk Pink': {
          'Small (38–42mm)': 49185764049079,
          'Large (44–49mm)': 49185764081847,
          '20 mm': 49185763983543,
          '22 mm': 49185764016311
        },
        'Mermaid Pink': {
          'Small (38–42mm)': 49185764180151,
          'Large (44–49mm)': 49185764212919,
          '20 mm': 49185764114615,
          '22 mm': 49185764147383
        },
        'Aurora Pink': {
          'Small (38–42mm)': 49185765097655,
          'Large (44–49mm)': 49185765130423,
          '20 mm': 49185765032119,
          '22 mm': 49185765064887
        },
        'Rose & Mint': {
          'Small (38–42mm)': 49185767096503,
          'Large (44–49mm)': 49185767129271,
          '20 mm': 49185767030967,
          '22 mm': 49185767063735
        },
        'Strawberry': {
          'Small (38–42mm)': 49185767227575,
          'Large (44–49mm)': 49185767260343,
          '20 mm': 49185767162039,
          '22 mm': 49185767194807
        },
        'Fuchsia': {
          'Small (38–42mm)': 49185764442295,
          'Large (44–49mm)': 49185764475063,
          '20 mm': 49185764376759,
          '22 mm': 49185764409527
        },
        'Sunset': {
          'Small (38–42mm)': 49185778925751,
          'Large (44–49mm)': 49185778958519,
          '20 mm': 49185778860215,
          '22 mm': 49185778892983
        },
        'Black Coral': {
          'Small (38–42mm)': 49185782300855,
          'Large (44–49mm)': 49185782333623,
          '20 mm': 49185782235319,
          '22 mm': 49185782268087
        },
        'Plum Blossom': {
          'Small (38–42mm)': 49185782038711,
          'Large (44–49mm)': 49185782071479,
          '20 mm': 49185781973175,
          '22 mm': 49185782005943
        },
        'Merlot': {
          'Small (38–42mm)': 49185778663607,
          'Large (44–49mm)': 49185778696375,
          '20 mm': 49185778598071,
          '22 mm': 49185778630839
        },
        'Ink Violet': {
          'Small (38–42mm)': 49185767358647,
          'Large (44–49mm)': 49185767391415,
          '20 mm': 49185767293111,
          '22 mm': 49185767325879
        },
        'Porcelain Blue': {
          'Small (38–42mm)': 49185782169783,
          'Large (44–49mm)': 49185782202551,
          '20 mm': 49185782104247,
          '22 mm': 49185782137015
        },
        'Periwinkle': {
          'Small (38–42mm)': 49185779351735,
          'Large (44–49mm)': 49185779384503,
          '20 mm': 49185779286199,
          '22 mm': 49185779318967
        },
        'Galaxy Blue': {
          'Small (38–42mm)': 49185766834359,
          'Large (44–49mm)': 49185766867127,
          '20 mm': 49185765327031,
          '22 mm': 49185765359799
        },
        'Midnight Bloom': {
          'Small (38–42mm)': 49185767489719,
          'Large (44–49mm)': 49185767522487,
          '20 mm': 49185767424183,
          '22 mm': 49185767456951
        },
        'Pastel Sky': {
          'Small (38–42mm)': 49185764573367,
          'Large (44–49mm)': 49185764606135,
          '20 mm': 49185764507831,
          '22 mm': 49185764540599
        },
        'Moonlight': {
          'Small (38–42mm)': 49185766965431,
          'Large (44–49mm)': 49185766998199,
          '20 mm': 49185766899895,
          '22 mm': 49185766932663
        },
        'Ice Blue': {
          'Small (38–42mm)': 49185781252279,
          'Large (44–49mm)': 49185781285047,
          '20 mm': 49185781186743,
          '22 mm': 49185781219511
        },
        'Cornflower': {
          'Small (38–42mm)': 49185781514423,
          'Large (44–49mm)': 49185781547191,
          '20 mm': 49185781448887,
          '22 mm': 49185781481655
        },
        'Emerald': {
          'Small (38–42mm)': 49185764311223,
          'Large (44–49mm)': 49185764343991,
          '20 mm': 49185764245687,
          '22 mm': 49185764278455
        },
        'Sea Glass': {
          'Small (38–42mm)': 49185779220663,
          'Large (44–49mm)': 49185779253431,
          '20 mm': 49185779155127,
          '22 mm': 49185779187895
        },
        'Peach & Sage': {
          'Small (38–42mm)': 49185768341687,
          'Large (44–49mm)': 49185778270391,
          '20 mm': 49185768276151,
          '22 mm': 49185768308919
        },
        'Jade': {
          'Small (38–42mm)': 49185781645495,
          'Large (44–49mm)': 49185781678263,
          '20 mm': 49185781579959,
          '22 mm': 49185781612727
        },
        'Black': {
          'Small (38–42mm)': 49185782431927,
          'Large (44–49mm)': 49185782464695,
          '20 mm': 49185782366391,
          '22 mm': 49185782399159
        },
        'Black Marble': {
          'Small (38–42mm)': 49185782562999,
          'Large (44–49mm)': 49185782595767,
          '20 mm': 49185782497463,
          '22 mm': 49185782530231
        },
        'Candy Swirl': {
          'Small (38–42mm)': 49185778532535,
          'Large (44–49mm)': 49185778565303,
          '20 mm': 49185778466999,
          '22 mm': 49185778499767
        },
        'Amber': {
          'Small (38–42mm)': 49185781776567,
          'Large (44–49mm)': 49185781809335,
          '20 mm': 49185781711031,
          '22 mm': 49185781743799
        },
        'Clear': {
          'Small (38–42mm)': 49185779777719,
          'Large (44–49mm)': 49185781153975,
          '20 mm': 49185779712183,
          '22 mm': 49185779744951
        }
      }
    },
    "zebra-makeup-bag": {
      "type": "shaded",
      "singleTitle": "Buy 1 Bag",
      "shadeHeader": "Color",
      "defaultShade": "Black",
      "b2g3": false,
      "defaultOffer": "bogo",
      "unitLabel": "Bag",
      "shades": [
        {
          "name": "Black",
          "hex": "#000000"
        },
        {
          "name": "Blue",
          "hex": "#152743"
        },
        {
          "name": "Red",
          "hex": "#8D0201"
        },
        {
          "name": "Brown",
          "hex": "#2D150E"
        }
      ],
      "variantIds": {
        "Black": 49135784329399,
        "Blue": 49135784427703,
        "Red": 49135784526007,
        "Brown": 49135784624311
      }
    },
    /* ⚠️ INSERE EN TETE, PAS EN QUEUE — et c'est structurel, pas un choix de gout : la DERNIERE
       entree de la map ne porte pas de virgule finale, donc « ajouter a la fin » modifierait sa
       ligne et casserait le gate additif de check-additive-js.sh. Une entree neuve ne peut
       qu'etre INSEREE devant une entree deja suivie d'une virgule. */
    'jacquard-leg-warmers': {
      /* Development PDP (Sunday Leg Warmers - 2 Pairs), product DRAFT. THREE single-axis
         colours, so the shared pill row stays at every width — no per-SKU dropdown.
         ONE price for a 2-pair pack, no BxGy discount object and no offer tier
         (pdp-copy/jacquard-leg-warmers.md § Offer) -> `noBogo: true`, and deliberately no
         `b2g3` / `defaultOffer` keys. NOTE the engine gap this entry lives with: the shared
         runtime honours `noBogo` only on the `type: 'single'` path; on `shaded` it builds the
         "Buy 1, Get 1 Free" label unconditionally, so that label is hidden per-SKU in
         snippets/jlw-variant-swap.liquid rather than by editing the shared engine.
         Variant ids are the 2026-09-14 Shopify read-back (product 8779818991799).
         Swatch hexes are median-RGB probes over a plain rib field of the frozen 1688 SKU
         images (sha-bound in visuals/jacquard-leg-warmers/pdp-draft/source/1688/sku-images/
         MANIFEST.tsv); the probe boxes are recorded in pdp-draft/PAGE-BUILD-2026-09-14.md and
         the image lane's own hex-probes.md supersedes them when its wave lands. */
      type: 'shaded',
      singleTitle: 'Buy 2 Pairs',
      shadeHeader: 'Color',
      defaultShade: 'Cream',
      noBogo: true,
      unitLabel: 'Pair',
      shades: [
        { name: 'Cream',    hex: '#DBD3C2' },
        { name: 'Charcoal', hex: '#797778' },
        { name: 'Black',    hex: '#11100D' }
      ],
      variantIds: {
        'Cream':    49181372940471,
        'Charcoal': 49181373563063,
        'Black':    49181373595831
      }
    },
    'five-pair-socks': {
      /* Development PDP (Five-Pair Socks), product DRAFT. ONE unit = FIVE pairs (one of each
         colour), a single variant with no colour option, so type: 'single' and no shade pills.
         One price for the five-pair pack, no BxGy discount object and no offer tier
         (pdp-copy/five-pair-socks.md section Offer) -> noBogo: true. Variant id is the
         2026-09-20 Shopify read-back (product 8794033553591, single 'Default Title' variant). */
      type: 'single',
      singleTitle: 'Buy 5 Pairs',
      noBogo: true,
      variantId: 49214641307831
    },
    'foldable-standing-makeup-bag': {
      /* The supplier's complete Large Triangle Stripes assortment: six Color values, all in
         the same 20 x 11 x 18 cm construction. Variant ids come from the 2026-09-09 Shopify
         read-back; swatches are the source-image probes recorded in working/qc/hex-probes.md. */
      type: 'shaded',
      singleTitle: 'Buy 1 Bag',
      shadeHeader: 'Color',
      defaultShade: 'Brown',
      b2g3: false,
      defaultOffer: 'bogo',
      unitLabel: 'Bag',
      shades: [
        { name: 'Brown',      hex: '#915029' },
        { name: 'Pink',       hex: '#E3C5C8' },
        { name: 'Apricot',    hex: '#7B684A' },
        { name: 'Light Blue', hex: '#A4B9C1' },
        { name: 'Black',      hex: '#222222' },
        { name: 'Navy',       hex: '#474F64' }
      ],
      variantIds: {
        'Brown':      49129277882551,
        'Pink':       49132981846199,
        'Apricot':    49132981878967,
        'Light Blue': 49132981911735,
        'Black':      49132981944503,
        'Navy':       49132981977271
      }
    },
    'quilted-hair-tool-organizer': {
      /* Development PDP. Six single-axis colors in the founder-approved sales order.
         Swatches are median RGB probes from the supplier color masters; variant ids are
         the phase-4 Shopify read-back in pdp-draft/shopify-gids.json. */
      type: 'shaded',
      singleTitle: 'Buy 1 Organizer',
      shadeHeader: 'Color',
      defaultShade: 'Blue Floral',
      b2g3: false,
      defaultOffer: 'bogo',
      unitLabel: 'Organizer',
      shades: [
        { name: 'Blue Floral', hex: '#CBC8C8' },
        { name: 'Black Bow', hex: '#161516' },
        { name: 'Ivory Bow', hex: '#DDCCB8' },
        { name: 'Pink Bow', hex: '#D9CFC6' },
        { name: 'Teddy', hex: '#DBCCC1' },
        { name: 'Rose Lattice', hex: '#DECAC4' },
      ],
      variantIds: {
        'Blue Floral': 49125689491639,
        'Black Bow': 49125689524407,
        'Ivory Bow': 49125689557175,
        'Pink Bow': 49125689589943,
        'Teddy': 49125689622711,
        'Rose Lattice': 49125689655479,
      }
    },
    'adjustable-fur-slippers': {
      /* Development PDP. 5 colourways x US 6-9 whole = 20 variants (Surya 2026-09-06: Taupe /
         Cream / Black / Blush Pink / Panda, the supplier's full palette; the run was narrowed
         from EU 35-40 to US 6-9 so every size we sell is covered by Thomas's approved chart
         rows). THIRD two-option SKU of the store - `sizes` + nested `variantIds` is a CONFIG
         entry, not an engine change: the capability has shipped since 2026-09-03.
         Swatch hexes are the image lane's measured supplier probes, read out of
         visuals/adjustable-fur-slippers/2026-09-06/working/w2-w3/qc/hex-probes.md (median RGB
         over an eye-picked flat fur field per colourway). Nothing here re-measures them. */
      type: 'shaded',
      singleTitle: 'Buy 1 Pair',
      shadeHeader: 'Color',
      defaultShade: 'Taupe',
      unitLabel: 'Pair',
      /* PANDA IS TWO-TONE and its pill carries the CREAM band tone alone (#DCCDB8), not a
         split. Reason, measured rather than felt: `--pill-color` feeds BOTH
         `background: var(--pill-color)` (where a gradient would render) AND
         `.is-selected { box-shadow: 0 0 0 1.5px #FFF, 0 0 0 3px var(--pill-color) }`, where a
         gradient is not a valid colour - the whole declaration is dropped and that pill loses
         its selected ring. The existing mechanism does not carry a two-tone pill cleanly.
         Between the two probed tones, cream is also the separable one: panda-black #090708 vs
         the Black colourway #010202 is dE76 1.82 (indistinguishable), while panda-cream
         #DCCDB8 vs the Cream colourway #DEC6A7 is dE76 6.88. A two-tone pill would be the
         honest control and needs a per-SKU snippet rule plus a solid-colour ring override -
         recorded as an open founder call, never smuggled into this shared file. */
      shades: [
        { name: 'Taupe',      hex: '#77583D' },
        { name: 'Cream',      hex: '#DEC6A7' },
        { name: 'Black',      hex: '#010202' },
        { name: 'Blush Pink', hex: '#AB7676' },
        { name: 'Panda',      hex: '#DCCDB8' }
      ],
      sizeHeader: 'Size',
      /* Libelle affiche DANS le <select> : « US Women 8 », pas « Size 8 » - la cliente
         americaine lit une pointure US et le guide des tailles est US-first. La VALEUR des
         options reste la cle nue de `variantIds`. */
      sizeOptionLabel: 'US Women',
      sizes: ['6', '7', '8', '9'],
      /* MISSING marker volontaire : `defaultSize` n'est retenu que s'il appartient a `sizes`,
         donc cette valeur laisse la selection VIDE -> fail closed a l'ajout panier tant
         qu'aucun arbitrage merchandising n'a designe la pointure modale. */
      defaultSize: '/* MISSING: no ruling - the modal US women size is a merchandising call, not a measurement */',
      variantIds: {
        'Taupe': {
          '6': 49120528302263,
          '7': 49120528597175,
          '8': 49120528629943,
          '9': 49120528662711
        },
        'Cream': {
          '6': 49120528695479,
          '7': 49120528728247,
          '8': 49120528761015,
          '9': 49120528793783
        },
        'Black': {
          '6': 49120528826551,
          '7': 49120528859319,
          '8': 49120528892087,
          '9': 49120528924855
        },
        'Blush Pink': {
          '6': 49120528957623,
          '7': 49120528990391,
          '8': 49120529023159,
          '9': 49120529055927
        },
        'Panda': {
          '6': 49120529088695,
          '7': 49120529121463,
          '8': 49120529154231,
          '9': 49120529186999
        }
      }
    },
    'barefoot-travel-slipper-socks': {
      /* Development PDP. 3 colourways x 6 US bands = 18 variants (Surya 2026-09-06:
         Cream · Grey · Black, the supplier's literal 白色 "white" deliberately not used
         because the pixels read cream). Swatch hexes measured from the colourway masters
         2026-09-06; the Grey master is still `ready-for-user-review`, see the header.
         DEUXIEME PRODUIT A DEUX OPTIONS du store - d'ou `sizes` + `variantIds` imbrique. */
      type: 'shaded',
      singleTitle: 'Buy 1 Pair',
      shadeHeader: 'Color',
      defaultShade: 'Grey',
      b2g3: false,
      defaultOffer: 'bogo',
      unitLabel: 'Pair',
      shades: [
        { name: 'Cream', hex: '#DDD0C3' },
        { name: 'Grey', hex: '#6A655D' },
        { name: 'Black', hex: '#121110' }
      ],
      sizeHeader: 'Size',
      /* Libelle affiche DANS le <select>. Les VALEURS sont des bandes US FEMME nues
         ("8-8.5"). Le prefixe etait reduit au seul pays ("US 8-8.5") parce que "US Women"
         DEBORDAIT : mesure du 2026-09-07 matin, 7 rangees sur 8 tronquaient a 375px
         ("US Women 10.5..."), l'ellipse mangeant toute la queue "-11.5".
         ARBITRAGE SURYA du 2026-09-07 (grill, regle 2) : « 'US Women' + widen the select »
         — donc on aligne sur le gabarit mailbox ET on elargit, au lieu de choisir. La
         largeur vient de xts-variant-swap.liquid §4 (cause racine : `.adirena-size__row`
         etait dimensionne par son contenu, donc le `width:100%` du select se resolvait
         contre une boite que le select venait lui-meme de dimensionner). RE-MESURE apres
         correctif, 375px ET 360px, tous paliers, avec le nom de coloris le PLUS LARGE :
         8 rangees sur 8 tiennent, 8 sur 8 sur une seule ligne, 0 nom tronque.
         Ne touche JAMAIS l'attribut `value` : la cle nue de `variantIds` est inchangee. */
      sizeOptionLabel: 'US Women',
      sizes: [
        '5-6',
        '6.5-7.5',
        '8-8.5',
        '9-10',
        '10.5-11.5',
        '12-13'
      ],
      /* MISSING marker volontaire : `defaultSize` n'est retenu que s'il appartient a `sizes`,
         donc cette valeur laisse la selection VIDE -> fail closed. Le gate refuse d'ailleurs
         un defaultSize present dans `sizes`. */
      defaultSize: '/* MISSING: no ruling — the modal band is a merchandising call, not a measurement */',
      variantIds: {
        'Cream': {
          '5-6':       49120386646199,
          '6.5-7.5':   49120388186295,
          '8-8.5':     49120388219063,
          '9-10':      49120388251831,
          '10.5-11.5': 49120388284599,
          '12-13':     49120388317367
        },
        'Grey': {
          '5-6':       49120388350135,
          '6.5-7.5':   49120388382903,
          '8-8.5':     49120388415671,
          '9-10':      49120388448439,
          '10.5-11.5': 49120388481207,
          '12-13':     49120388513975
        },
        'Black': {
          '5-6':       49120388546743,
          '6.5-7.5':   49120388579511,
          '8-8.5':     49120388612279,
          '9-10':      49120388645047,
          '10.5-11.5': 49120388677815,
          '12-13':     49120388710583
        }
      }
    },
    'metal-resin-watch-band': {
      type: 'shaded',
      singleTitle: 'Buy 1 Band',
      shadeHeader: 'Color',
      defaultShade: 'Rainbow · Rose Gold',
      defaultOffer: 'bogo',
      unitLabel: 'Band',
      sizeHeader: 'Size',
      /* EMPTY prefix, deliberate: the compound case-size values below are the whole
         option label (founder option-B ruling); the engine's null-aware fallback
         (2026-09-07) lets '' mean "no prefix" instead of falling back to 'Size'. */
      sizeOptionLabel: '',
      /* Deliberate MISSING marker: not a member of `sizes`, so DEFAULT_SIZE resolves to ''
         and the control opens on its placeholder with nothing preselected. See RULING #1. */
      defaultSize: '/* RULED fail-closed 2026-09-07 (Surya, by house precedent: the live slippers entry ships the same empty default — a size is the customer\'s own watch, never preselected) */',
      sizes: [
        'Small (38–42mm)',
        'Large (44–49mm)'
      ],
      shades: [
        { name: 'Rainbow · Rose Gold', hex: '#A15E35' },
        { name: 'Rainbow · Silver', hex: '#E18A41' },
        { name: 'Rainbow · Black', hex: '#A6B6C0' },
        { name: 'Pearl White · Rose Gold', hex: '#DAC8B1' },
        { name: 'Pearl White · Silver', hex: '#D9D3DC' },
        { name: 'Pearl White · Black', hex: '#CEBEA8' },
        { name: 'Pink & Green · Rose Gold', hex: '#E8CAB5' },
        { name: 'Pink & Green · Silver', hex: '#A1855D' },
        { name: 'Pink & Green · Black', hex: '#F0D2AC' },
        { name: 'Blue Floral · Rose Gold', hex: '#4B5965' },
        { name: 'Blue Floral · Silver', hex: '#545E6A' },
        { name: 'Blue Floral · Black', hex: '#55636F' },
        { name: 'Wood Grain · Rose Gold', hex: '#72593A' },
        { name: 'Wood Grain · Silver', hex: '#7F5337' },
        { name: 'Wood Grain · Black', hex: '#C5A685' }
      ],
      variantIds: {
        'Rainbow · Rose Gold': {
          'Small (38–42mm)': '49116382888119',
          'Large (44–49mm)': '49116383051959'
        },
        'Rainbow · Silver': {
          'Small (38–42mm)': '49116383084727',
          'Large (44–49mm)': '49116383117495'
        },
        'Rainbow · Black': {
          'Small (38–42mm)': '49116383150263',
          'Large (44–49mm)': '49116383183031'
        },
        'Pearl White · Rose Gold': {
          'Small (38–42mm)': '49116383215799',
          'Large (44–49mm)': '49116383248567'
        },
        'Pearl White · Silver': {
          'Small (38–42mm)': '49116383281335',
          'Large (44–49mm)': '49116383314103'
        },
        'Pearl White · Black': {
          'Small (38–42mm)': '49116383346871',
          'Large (44–49mm)': '49116383379639'
        },
        'Pink & Green · Rose Gold': {
          'Small (38–42mm)': '49116383412407',
          'Large (44–49mm)': '49116383445175'
        },
        'Pink & Green · Silver': {
          'Small (38–42mm)': '49116383477943',
          'Large (44–49mm)': '49116383510711'
        },
        'Pink & Green · Black': {
          'Small (38–42mm)': '49116383543479',
          'Large (44–49mm)': '49116383576247'
        },
        'Blue Floral · Rose Gold': {
          'Small (38–42mm)': '49116383609015',
          'Large (44–49mm)': '49116383641783'
        },
        'Blue Floral · Silver': {
          'Small (38–42mm)': '49116383674551',
          'Large (44–49mm)': '49116383707319'
        },
        'Blue Floral · Black': {
          'Small (38–42mm)': '49116383740087',
          'Large (44–49mm)': '49116383772855'
        },
        'Wood Grain · Rose Gold': {
          'Small (38–42mm)': '49116383805623',
          'Large (44–49mm)': '49116383838391'
        },
        'Wood Grain · Silver': {
          'Small (38–42mm)': '49116383871159',
          'Large (44–49mm)': '49116383903927'
        },
        'Wood Grain · Black': {
          'Small (38–42mm)': '49116383936695',
          'Large (44–49mm)': '49116383969463'
        }
      }
    },
    'chestnut-fuzzy-ankle-slippers': {
      /* Development PDP. 4 colorways x US 6-11 whole sizes = 24 variants (Surya 2026-09-03:
         full supplier palette ships — Camel [ex-Khaki, renamed store-side 2026-09-03] · Sand ·
         Black · Grey; the source family's halves and Wide widths stay a deliberate exclusion
         at launch). Swatch hexes measured from the supplier SKU pixels 2026-09-03.
         PREMIER PRODUIT A DEUX OPTIONS du store — d'ou `sizes` + `variantIds` imbrique. */
      type: 'shaded',
      singleTitle: 'Buy 1 Pair',
      shadeHeader: 'Color',
      defaultShade: 'Camel',
      unitLabel: 'Pair',
      shades: [
        { name: 'Camel', hex: '#9D6B46' },
        { name: 'Sand',  hex: '#BCA69B' },
        { name: 'Black', hex: '#393A3C' },
        { name: 'Brown', hex: '#594239' },
        { name: 'Grey',  hex: '#908E93' }
      ],
      sizeHeader: 'Size',
      /* Libelle affiche DANS le <select> (Surya 2026-09-03) : « US Women 6 », pas « Size 6 ».
         La cliente americaine lit une pointure US, et le guide des tailles est desormais
         US-first. La VALEUR des options reste la cle nue de `variantIds`. */
      sizeOptionLabel: 'US Women',
      sizes: ['6', '7', '8', '9', '10', '11'],
      /* MISSING marker volontaire : `defaultSize` n'est retenu que s'il appartient a `sizes`,
         donc cette valeur laisse la selection VIDE -> fail closed tant qu'aucun arbitrage
         merchandising n'a designe la pointure modale. */
      defaultSize: '/* MISSING: no ruling — the modal US women\'s size is a merchandising call, not a measurement */',
      variantIds: {
        'Camel': {
          '6':  49104214851767,
          '7':  49104215769271,
          '8':  49104215802039,
          '9':  49104215834807,
          '10': 49104215867575,
          '11': 49104215900343
        },
        'Sand': {
          '6':  49104215933111,
          '7':  49104215965879,
          '8':  49104215998647,
          '9':  49104216031415,
          '10': 49104216064183,
          '11': 49104216096951
        },
        'Black': {
          '6':  49108849754295,
          '7':  49108849787063,
          '8':  49108849819831,
          '9':  49108849852599,
          '10': 49108849885367,
          '11': 49108849918135
        },
        'Brown': {
          '6':  49186856763575,
          '7':  49186856796343,
          '8':  49186856829111,
          '9':  49186856861879,
          '10': 49186856894647,
          '11': 49186856927415
        },
        'Grey': {
          '6':  49108849950903,
          '7':  49108849983671,
          '8':  49108850016439,
          '9':  49108850049207,
          '10': 49108850081975,
          '11': 49108850114743
        }
      }
    },
    'acrylic-beaded-choker': {
      /* FULL-31 supplier run (Surya ruling 2026-09-06): every supplier colour SKU, 1:1 by
         supplier name; swatch hexes MEASURED from the gate-approved wave-3 shade masters
         (visuals/acrylic-beaded-choker/2026-08-31/working/wave3-qc/swatch-hexes-31.json).
         'Burgundy' is Thomas's 2026-09-06 variant carrying the wine-red supplier SKU. */
      type: 'shaded',
      singleTitle: 'Buy 1 Choker',
      shadeHeader: 'Color',
      defaultShade: 'Turquoise Blue',
      b2g3: true,
      defaultOffer: 'bogo',
      unitLabel: 'Choker',
      shades: [
        { name: 'Turquoise Blue', hex: '#45BFC3' },
        { name: 'White', hex: '#DED2BE' },
        { name: 'Light Blue', hex: '#B6C3E5' },
        { name: 'Red', hex: '#C73939' },
        { name: 'Mint Green', hex: '#7DB7A2' },
        { name: 'Amber', hex: '#7A3A1B' },
        { name: 'Green', hex: '#274D30' },
        { name: 'Yellow', hex: '#E6CA37' },
        { name: 'Navy Blue', hex: '#263051' },
        { name: 'Pink', hex: '#DD908F' },
        { name: 'Taupe', hex: '#685848' },
        { name: 'Magenta', hex: '#EB4B93' },
        { name: 'Purple', hex: '#8954A1' },
        { name: 'Orange', hex: '#F1780A' },
        { name: 'Black', hex: '#453E3D' },
        { name: 'Olive', hex: '#A49733' },
        { name: 'Ice White', hex: '#D2CEC9' },
        { name: 'Grey', hex: '#94878E' },
        { name: 'Stone Turquoise', hex: '#39ACA7' },
        { name: 'Crystal Purple', hex: '#9F628F' },
        { name: 'Burgundy', hex: '#6C2A31' },
        { name: 'Rust', hex: '#AC4330' },
        { name: 'Orchid', hex: '#AA4E8E' },
        { name: 'Caramel', hex: '#9D611F' },
        { name: 'Rainbow Mix', hex: '#CD9A8B' },  /* WEAK: multicolour bead, one swatch is a median; Surya's eye */
        { name: 'Jewel Mix', hex: '#795346' },  /* WEAK: multicolour bead, one swatch is a median; Surya's eye */
        { name: 'Sky & Caramel', hex: '#9A9492' },  /* WEAK: multicolour bead, one swatch is a median; Surya's eye */
        { name: 'Red, White & Black', hex: '#AE4038' },  /* WEAK: multicolour bead, one swatch is a median; Surya's eye */
        { name: 'Red & Black', hex: '#782A26' },  /* WEAK: multicolour bead, one swatch is a median; Surya's eye */
        { name: 'Navy & Olive', hex: '#76725E' },  /* WEAK: multicolour bead, one swatch is a median; Surya's eye */
        { name: 'Wine & White', hex: '#7C4143' },  /* WEAK: multicolour bead, one swatch is a median; Surya's eye */
      ],
      variantIds: {
        'Turquoise Blue': 49098525016247,
        'White': 49098525376695,
        'Light Blue': 49098525474999,
        'Red': 49098525507767,
        'Mint Green': 49098525540535,
        'Amber': 49098525409463,
        'Green': 49098525442231,
        'Yellow': 49112872452279,
        'Navy Blue': 49112872485047,
        'Pink': 49112872517815,
        'Taupe': 49112872550583,
        'Magenta': 49112872583351,
        'Purple': 49112872616119,
        'Orange': 49112872648887,
        'Black': 49112872681655,
        'Olive': 49120040681655,
        'Ice White': 49120040714423,
        'Grey': 49120040747191,
        'Stone Turquoise': 49120040779959,
        'Crystal Purple': 49120040812727,
        'Burgundy': 49118504517815,
        'Rust': 49120040878263,
        'Orchid': 49120040911031,
        'Caramel': 49120040943799,
        'Rainbow Mix': 49120040976567,
        'Jewel Mix': 49120041009335,
        'Sky & Caramel': 49120041042103,
        'Red, White & Black': 49120041074871,
        'Red & Black': 49120041107639,
        'Navy & Olive': 49120041140407,
        'Wine & White': 49120041173175
      }
    },
    'round-square-halo-stud-set': {
      type: 'shaded',
      singleTitle: 'Buy 1 Set',
      shadeHeader: 'Finish',
      defaultShade: 'White Gold',
      unitLabel: 'Set',
      cartIncludes: 'Round pair + square pair · 4 earrings',
      shades: [
        { name: 'White Gold', hex: '#B8BDC4' },
        { name: 'Gold', hex: '#C5A15A' },
        { name: 'Rose Gold', hex: '#C98F82' }
      ],
      variantIds: {
        'Gold': 49096344699063,
        'White Gold': 49096344731831,
        'Rose Gold': 49100642681015
      }
    },
    'crystal-spinner-anxiety-ring': {
      type: 'shaded',
      singleTitle: 'Buy 1 Ring',
      shadeHeader: 'Finish',
      defaultShade: 'Gold',
      unitLabel: 'Ring',
      shades: [
        { name: 'Gold', hex: '#C5A15A' },
        { name: 'Silver', hex: '#B8BDC4' },
        { name: 'Rose Gold', hex: '#C69A7D' }
      ],
      variantIds: {
        'Gold': 49104895803575,
        'Silver': 49104897769655,
        'Rose Gold': 49104897999031
      }
    },
    'wired-cotton-headband': {
      type: 'shaded',
      singleTitle: 'Buy 1 Headband',
      shadeHeader: 'Pattern',
      defaultShade: 'Black Chevron',
      unitLabel: 'Headband',
      b2g3: true,
      defaultOffer: 'b2g3',
      shades: [
        { name: 'Black Chevron', hex: '#1C1C1C' },
        { name: 'Aqua Floral', hex: '#78B7BC' },
        { name: 'Red Paisley', hex: '#A62324' },
        { name: 'Olive Floral', hex: '#67703B' },
        { name: 'Charcoal Blush', hex: '#66585C' },
        { name: 'Blue Floral', hex: '#426EAE' }
      ],
      variantIds: {
        'Black Chevron': 49019755069623,
        'Aqua Floral': 49019755102391,
        'Red Paisley': 49019755135159,
        'Olive Floral': 49020538716343,
        'Charcoal Blush': 49020538749111,
        'Blue Floral': 49020538781879
      }
    },
    'wired-cotton-headband-review': {
      /* Review-only WCH PDP. Pattern names remain deliberately provisional until the
         supplier mapping is reconciled; variant IDs are the live Shopify variants. */
      type: 'shaded',
      singleTitle: 'Buy 1 Headband',
      shadeHeader: 'Pattern',
      defaultShade: 'Pattern A',
      unitLabel: 'Headband',
      b2g3: true,
      shades: [
        { name: 'Pattern A', hex: '#7D8D91' },
        { name: 'Pattern B', hex: '#B36D5B' },
        { name: 'Pattern C', hex: '#747A58' }
      ],
      variantIds: {
        'Pattern A': 49019755069623,
        'Pattern B': 49019755102391,
        'Pattern C': 49019755135159
      }
    },
    'cover-cream-volufiline': {
      /* Consolidated to single SKU "Natural" 2026-06-03 — it color-adapts, so one shade serves all.
         single → no shade pills + shade quiz auto-masked (gate: type !== 'shaded').
         noBogo 2026-08-25 (decision Thomas) : offre BOGO retiree (fulfillment 2u bloque). */
      type: 'single',
      singleTitle: 'Buy 1 Stick',
      noBogo: true,
      variantId: 48472738136247
    },
    'perfect-brow-mapping-kit': {
      /* Lean companion PDP: single kit, no BOGO or shade selector. */
      type: 'single',
      singleTitle: 'Buy 1 Kit',
      noBogo: true,
      variantId: 49089241383095
    },
    'bubble-mask-30s': {
      type: 'single',
      singleTitle: 'Buy 1 Mask',
      variantId: 48500197654711
    },
    'bubble-mask-clay': {
      type: 'single',
      singleTitle: 'Buy 1 Mask',
      variantId: 48500197916855
    },
    'peel-reveal-brow-tint': {
      /* Shaded 2026-07-30 : 4 teintes OLIBOLLA (fiche fournisseur Flowpallet 2074393573268393985) — noms fournisseur verrouilles 2026-07-31 : 01 Espresso / 02 Taupe / 03 Auburn / 04 Chocolate (ordre selecteur = ordre fournisseur).
         Hex SAMPLES en PIL sur la planche fournisseur fp-09.jpg, verifies au zoom, jamais devines.
         SKU alignes sur le numero fournisseur (ADR-PRB-00N = teinte 0N) pour le picking HAO.
         Quiz volontairement ABSENT : pas de faceShades ni de card-map, donc le module quiz ne se
         rend pas (gate safe, config GSE). La version "couleur de sourcils" est un net-new sur module
         partage -> theme draft + preview Thomas, 2e passe. */
      type: 'shaded',
      singleTitle: 'Buy 1 Tube',
      shadeHeader: 'Shade',
      defaultShade: 'Taupe',
      /* Palier B2G3 RETIRÉ le 2026-08-06 (décision Thomas). Le test « payer 2, recevoir 5 »
         reste actif sur GSE et VBL uniquement. La remise Shopify « Buy 2 Get 3 Free » de ce
         produit est désactivée (usages préservés) et sa déclaration retirée de
         ops-automation/config/products.json — les trois doivent rester cohérents. */
      shades: [
        { name: 'Espresso', hex: '#786A69' },
        { name: 'Taupe', hex: '#BC805C' },
        { name: 'Auburn', hex: '#8F4134' },
        { name: 'Chocolate', hex: '#8E5633' }
      ],
      variantIds: {
        'Espresso': 48939419893943,
        'Taupe': 48939419795639,
        'Auburn': 48939419861175,
        'Chocolate': 48939419828407
      }
    },
    'peel-reveal-brow-tint-ditching-microblading': {
      /* CLONE cache du PRB pour le listicle-buy "Ditching Microblading" (2026-08-12, decision Thomas :
         URL d'ads distincte de la PDP live). Produit gid 8707916431543, memes SKU ADR-PRB-00N
         (picking HAO inchange), inventaire non tracke, tag bogo, discount BxGy dedie.
         Entree ADDITIVE keyed-handle (regle #2) — copie de la config PRB avec les variant IDs du clone. */
      type: 'shaded',
      singleTitle: 'Buy 1 Tube',
      shadeHeader: 'Shade',
      defaultShade: 'Taupe',
      shades: [
        { name: 'Espresso', hex: '#786A69' },
        { name: 'Taupe', hex: '#BC805C' },
        { name: 'Auburn', hex: '#8F4134' },
        { name: 'Chocolate', hex: '#8E5633' }
      ],
      variantIds: {
        'Espresso': 48982989275319,
        'Taupe': 48982989308087,
        'Auburn': 48982989340855,
        'Chocolate': 48982989373623
      }
    },
    'peel-reveal-brow-tint-i-tested': {
      /* CLONE cache #2 du PRB pour le listicle-buy "I Tested" (2026-08-12). Produit gid 8708343660727,
         memes SKU ADR-PRB-00N, inventaire non tracke, tag bogo, discount BxGy dedie (combinesWith aligne
         flotte des la creation). Entree ADDITIVE keyed-handle (regle #2). */
      type: 'shaded',
      singleTitle: 'Buy 1 Tube',
      shadeHeader: 'Shade',
      defaultShade: 'Taupe',
      shades: [
        { name: 'Espresso', hex: '#786A69' },
        { name: 'Taupe', hex: '#BC805C' },
        { name: 'Auburn', hex: '#8F4134' },
        { name: 'Chocolate', hex: '#8E5633' }
      ],
      variantIds: {
        'Espresso': 48984431788215,
        'Taupe': 48984431820983,
        'Auburn': 48984431853751,
        'Chocolate': 48984431886519
      }
    },
    'peel-reveal-brow-tint-ultimate': {
      /* CLONE cache #3 du PRB — page d'OFFRE a 3 paliers (Buy 1 / BOGO / Ultimate Kit), 2026-08-13.
         Produit gid 8710578274487, memes SKU ADR-PRB-00N, inventaire non tracke, tag bogo +
         ab-test-invisible, seo.hidden=1, hors collection, BxGy dedie 1161886367927.
         Entree ADDITIVE keyed-handle (regle #2). */
      type: 'shaded',
      singleTitle: 'Buy 1 Tube',
      shadeHeader: 'Shade',
      defaultShade: 'Taupe',
      shades: [
        { name: 'Espresso', hex: '#786A69' },
        { name: 'Taupe', hex: '#BC805C' },
        { name: 'Auburn', hex: '#8F4134' },
        { name: 'Chocolate', hex: '#8E5633' }
      ],
      variantIds: {
        'Espresso': 48991192383671,
        'Taupe': 48991192416439,
        'Auburn': 48991192449207,
        'Chocolate': 48991192481975
      }
    },
    'gel-eyeshadow-stick': {
      /* Shaded 2026-07-10 : 10 teintes Timephoria-order (Thomas). Quiz volontairement absent
         (pas de faceShades ni de card-map → le module quiz ne se rend pas, gate safe). */
      type: 'shaded',
      singleTitle: 'Buy 1 Stick',
      shadeHeader: 'Shade',
      defaultShade: 'Moonshell',
      /* TEST 2026-07-30 : 3e palier « payer 2, recevoir 5 ». Simple CLÉ DE CONFIG —
         la logique est générique (cf. TIER_B2G3). Discount Shopify : « Buy 2, Get 3 Free ». */
      b2g3: true,
      /* TEST 2026-08-12 (Thomas) : l'offre PRÉ-COCHÉE devient le palier B2G3 au lieu du BOGO.
         Clé de config par handle — la logique reste générique (Règle #2 : aucun SKU dans le code
         partagé). Retirer cette ligne = retour instantané au BOGO pré-coché. */
      defaultOffer: 'b2g3',
      shades: [
        { name: 'Moonshell', hex: '#E8D5BC' },
        { name: 'Blush Quartz', hex: '#D9A0A5' },
        { name: 'Zenith', hex: '#C9A8C9' },
        { name: 'Peach Pearl', hex: '#E3B491' },
        { name: 'Bronzite', hex: '#A98A72' },
        { name: 'Topaz', hex: '#B57F5E' },
        { name: 'Rose Stone', hex: '#C98D86' },
        { name: 'Chromite', hex: '#9B7D72' },
        { name: 'Diamond', hex: '#E5E0DC' },
        { name: 'Amethyst', hex: '#B593C4' }
      ],
      variantIds: {
        'Moonshell': 48858111606967,
        'Blush Quartz': 48861146284215,
        'Zenith': 48861146316983,
        'Peach Pearl': 48861146349751,
        'Bronzite': 48861146382519,
        'Topaz': 48861146415287,
        'Rose Stone': 48861146448055,
        'Chromite': 48861146480823,
        'Diamond': 48861146513591,
        'Amethyst': 48861146546359
      }
    },
    'gel-eyeshadow-stick-softfocus-review': {
      /* CLONE cache du GSE pour le listicle-buy "Soft Focus Review" (2026-08-12, twist +BUY :
         URL d'ads distincte de la PDP live). Produit gid 8708513759415, memes SKU ADR-SFGE-0NN
         (picking HAO inchange), inventaire non tracke, tag bogo, seo.hidden=1, discounts BxGy
         dedies (BOGO + B2G3, combinesWith aligne flotte des la creation).
         MIROIR EXACT de l'offre PDP live : b2g3 actif, B2G3 pre-coche.
         Entree ADDITIVE keyed-handle (regle #2) — copie de la config GSE avec les variant IDs du clone. */
      type: 'shaded',
      singleTitle: 'Buy 1 Stick',
      shadeHeader: 'Shade',
      defaultShade: 'Moonshell',
      b2g3: true,
      defaultOffer: 'b2g3',
      shades: [
        { name: 'Moonshell', hex: '#E8D5BC' },
        { name: 'Blush Quartz', hex: '#D9A0A5' },
        { name: 'Zenith', hex: '#C9A8C9' },
        { name: 'Peach Pearl', hex: '#E3B491' },
        { name: 'Bronzite', hex: '#A98A72' },
        { name: 'Topaz', hex: '#B57F5E' },
        { name: 'Rose Stone', hex: '#C98D86' },
        { name: 'Chromite', hex: '#9B7D72' },
        { name: 'Diamond', hex: '#E5E0DC' },
        { name: 'Amethyst', hex: '#B593C4' }
      ],
      variantIds: {
        'Moonshell': 48985242042551,
        'Blush Quartz': 48985242075319,
        'Zenith': 48985242108087,
        'Peach Pearl': 48985242140855,
        'Bronzite': 48985242173623,
        'Topaz': 48985242206391,
        'Rose Stone': 48985242239159,
        'Chromite': 48985242271927,
        'Diamond': 48985242304695,
        'Amethyst': 48985242337463
      }
    },
    'gel-eyeshadow-stick-ditching-palettes': {
      /* CLONE cache #2 du GSE pour le listicle-buy "Ditching Palettes" (2026-08-12, twist +BUY :
         2e URL d'ads distincte de la PDP live et du clone softfocus-review).
         Produit gid 8708539154615, memes SKU ADR-SFGE-0NN (picking HAO inchange), inventaire non
         tracke, tags bogo + ab-test-invisible, seo.hidden=1, hors collection Home Best Sellers,
         discounts BxGy dedies (BOGO 1161680847031 + B2G3 1161680879799, combinesWith copie a
         l'identique des discounts GSE originaux).
         MIROIR EXACT de l'offre PDP live : b2g3 actif, B2G3 pre-coche.
         Entree ADDITIVE keyed-handle (regle #2) — copie de la config GSE avec les variant IDs du clone. */
      type: 'shaded',
      singleTitle: 'Buy 1 Stick',
      shadeHeader: 'Shade',
      defaultShade: 'Moonshell',
      b2g3: true,
      defaultOffer: 'b2g3',
      shades: [
        { name: 'Moonshell', hex: '#E8D5BC' },
        { name: 'Blush Quartz', hex: '#D9A0A5' },
        { name: 'Zenith', hex: '#C9A8C9' },
        { name: 'Peach Pearl', hex: '#E3B491' },
        { name: 'Bronzite', hex: '#A98A72' },
        { name: 'Topaz', hex: '#B57F5E' },
        { name: 'Rose Stone', hex: '#C98D86' },
        { name: 'Chromite', hex: '#9B7D72' },
        { name: 'Diamond', hex: '#E5E0DC' },
        { name: 'Amethyst', hex: '#B593C4' }
      ],
      variantIds: {
        'Moonshell': 48985292832951,
        'Blush Quartz': 48985292865719,
        'Zenith': 48985292898487,
        'Peach Pearl': 48985292931255,
        'Bronzite': 48985292964023,
        'Topaz': 48985292996791,
        'Rose Stone': 48985293029559,
        'Chromite': 48985293062327,
        'Diamond': 48985293095095,
        'Amethyst': 48985293127863
      }
    },
    'bubble-mask-clay-draft-image-rework-2026-06': {
      /* DRAFT replica of Bubble Mask Clay (partner review). Same BOGO config, draft variant.
         Additive — only triggers on the draft handle. Remove when the draft is retired. */
      type: 'single',
      singleTitle: 'Buy 1 Mask',
      variantId: 48534691610807
    },
    'cover-cream-draft-image-rework-2026-06': {
      /* DRAFT replica of Cover Cream (partner review). Same BOGO config, draft variant.
         Additive — only triggers on the draft handle. Remove when the draft is retired. */
      type: 'single',
      singleTitle: 'Buy 1 Stick',
      variantId: 48534890938551
    },
    'changing-foundation-stick': {
      /* 2nd PDP for A/B testing (FaceLove buy-box replica). Separate invisible product,
         same single-SKU BOGO config. Additive — only triggers on this handle. */
      type: 'single',
      /* noBogo 2026-08-25 (decision Thomas) : offre BOGO retiree, cf. cover-cream. */
      noBogo: true,
      singleTitle: 'Buy 1 Stick',
      variantId: 48756600045751
    },
    'second-skin-serum-tint': {
      type: 'shaded',
      singleTitle: 'Buy 1 Tint',
      shadeHeader: 'Shade',
      defaultShade: 'Nature',
      shades: [
        { name: 'Nature',     hex: '#E8C19E' },
        { name: 'Wheat',      hex: '#E3C39A' },
        { name: 'Warm Beige', hex: '#D8AE86' },
        { name: 'Honey',      hex: '#D9A56B' }
      ],
      variantIds: {
        'Nature': 48509951639735,
        'Wheat': 48510054105271,
        'Warm Beige': 48510054072503,
        'Honey': 48510054039735
      },
      /* quiz: 6 tone-faces (fair→deep) → Nature/Wheat/Warm Beige/Honey */
      quiz: { faceShades: ['Wheat', 'Nature', 'Nature', 'Warm Beige', 'Honey', 'Honey'] }
    },
    'stellar-dust-lip-stain': {
      /* Run PDP v2 2026-08-24 : shaded 5 teintes fournisseur HAO, dropdown sans quiz
         (pas de faceShades ni de card-map -> le module quiz ne se rend pas, gate safe).
         Hex = PIL-samples des smears box 1688. Renommage 2026-08-25 (go Thomas, congruence
         ads->PDP) : titres clientes = noms du produit SOURCE cites dans les creas, match
         visuel frame vs swatch. SKU/variant IDs inchanges. Entree keyed-handle (regle #2). */
      type: 'shaded',
      singleTitle: 'Buy 1 Lip Stain',
      shadeHeader: 'Shade',
      defaultShade: 'Nova',
      shades: [
        { name: 'Axion', hex: '#DD7E92' },
        { name: 'Nova', hex: '#D76E84' },
        { name: 'Futura', hex: '#C96C65' },
        { name: 'Quanta', hex: '#A35141' },
        { name: 'Enigma', hex: '#B42749' }
      ],
      variantIds: {
        'Axion': 49044213891255,
        'Nova': 49044213858487,
        'Futura': 49044213956791,
        'Quanta': 49044213924023,
        'Enigma': 49044213989559
      }
    },
    'velvet-blur-lip-cream': {
      /* Wave lip/BB 2026-07-24 (clone Timephoria Nebula). Shaded 3, quiz OFF (cosmétique couleur).
         BOGO BxGy: DiscountAutomaticNode/1158462636215. Hex PIL-samplés sourcing HAO. */
      type: 'shaded',
      singleTitle: 'Buy 1 Lip Cream',
      shadeHeader: 'Shade',
      defaultShade: 'Moon Kiss',
      /* TEST 2026-08-04 : 3e palier « payer 2, recevoir 5 » (3e produit apres GSE et PRB).
         Simple CLÉ DE CONFIG — la logique est générique. Remise Shopify : « Buy 2, Get 3 Free! ». */
      b2g3: true,
      /* TEST 2026-08-15 (Thomas) : clone exact du pré-cochage GSE. Le palier B2G3 est
         sélectionné à l'ouverture ; BOGO reste visible et cliquable. Retirer cette ligne
         restaure instantanément le BOGO par défaut, sans toucher à la logique partagée. */
      defaultOffer: 'b2g3',
      shades: [
        { name: 'Moon Kiss', hex: '#C85461' },
        { name: 'Equinox', hex: '#D86A5F' },
        { name: 'Starblush', hex: '#DE6B68' },
        { name: 'Mauve Halo', hex: '#CD7074' },
        { name: 'Helion', hex: '#C62D35' },
        { name: 'Estelle', hex: '#A3383F' },
        { name: 'Lyra', hex: '#D88E83' },
        { name: 'Rose Veil', hex: '#CB857D' },
        { name: 'Cosmic Coral', hex: '#D17C6D' },
        { name: 'Aurora', hex: '#CF6860' },
        { name: 'Cordelia', hex: '#C47475' },
        { name: 'Leo', hex: '#B85F5E' }
      ],
      variantIds: {
        'Moon Kiss': 48924558557367,
        'Equinox': 48924558590135,
        'Starblush': 49021238247607,
        'Mauve Halo': 49021238280375,
        'Helion': 48945233330359,
        'Estelle': 48945233297591,
        'Lyra': 49021238313143,
        'Rose Veil': 49021238345911,
        'Cosmic Coral': 49021238378679,
        'Aurora': 48924558524599,
        'Cordelia': 49021238411447,
        'Leo': 49021238444215
      }
    },
    'velvet-blur-lip-cream-matte-again': {
      /* CLONE cache VBL pour le listicle-buy L-C « Lip Lines » (2026-08-14).
         Produit gid 8711082049719, memes SKU ADR-VBLC-001..005, inventaire non tracke,
         tags bogo + ab-test-invisible, seo.hidden=1, remises BOGO + B2G3 dediees.
         Entree ADDITIVE keyed-handle : miroir du master, IDs variantes du clone. */
      type: 'shaded',
      singleTitle: 'Buy 1 Lip Cream',
      shadeHeader: 'Shade',
      defaultShade: 'Moon Kiss',
      b2g3: true,
      shades: [
        { name: 'Moon Kiss', hex: '#C85461' },
        { name: 'Equinox', hex: '#D86A5F' },
        { name: 'Starblush', hex: '#DE6B68' },
        { name: 'Mauve Halo', hex: '#CD7074' },
        { name: 'Helion', hex: '#C62D35' },
        { name: 'Estelle', hex: '#A3383F' },
        { name: 'Lyra', hex: '#D88E83' },
        { name: 'Rose Veil', hex: '#CB857D' },
        { name: 'Cosmic Coral', hex: '#D17C6D' },
        { name: 'Aurora', hex: '#CF6860' },
        { name: 'Cordelia', hex: '#C47475' },
        { name: 'Leo', hex: '#B85F5E' }
      ],
      variantIds: {
        'Moon Kiss': 48992918667447,
        'Equinox': 48992918700215,
        'Starblush': 49021265903799,
        'Mauve Halo': 49021265936567,
        'Helion': 48992918765751,
        'Estelle': 48992918732983,
        'Lyra': 49021265969335,
        'Rose Veil': 49021266002103,
        'Cosmic Coral': 49021266034871,
        'Aurora': 48992918634679,
        'Cordelia': 49021266067639,
        'Leo': 49021266100407
      }
    },
    'velvet-blur-lip-cream-i-tested': {
      /* CLONE cache VBL pour le listicle-buy L-A « I Tested » (2026-08-14).
         Produit gid 8711085555895, memes SKU ADR-VBLC-001..005, inventaire non tracke,
         tags bogo + ab-test-invisible, seo.hidden=1, remises BOGO + B2G3 dediees.
         Entree ADDITIVE keyed-handle : miroir du master, IDs variantes du clone. */
      type: 'shaded',
      singleTitle: 'Buy 1 Lip Cream',
      shadeHeader: 'Shade',
      defaultShade: 'Moon Kiss',
      b2g3: true,
      shades: [
        { name: 'Moon Kiss', hex: '#C85461' },
        { name: 'Equinox', hex: '#D86A5F' },
        { name: 'Starblush', hex: '#DE6B68' },
        { name: 'Mauve Halo', hex: '#CD7074' },
        { name: 'Helion', hex: '#C62D35' },
        { name: 'Estelle', hex: '#A3383F' },
        { name: 'Lyra', hex: '#D88E83' },
        { name: 'Rose Veil', hex: '#CB857D' },
        { name: 'Cosmic Coral', hex: '#D17C6D' },
        { name: 'Aurora', hex: '#CF6860' },
        { name: 'Cordelia', hex: '#C47475' },
        { name: 'Leo', hex: '#B85F5E' }
      ],
      variantIds: {
        'Moon Kiss': 48992922370231,
        'Equinox': 48992922402999,
        'Starblush': 49021271703735,
        'Mauve Halo': 49021271736503,
        'Helion': 48992922468535,
        'Estelle': 48992922435767,
        'Lyra': 49021271769271,
        'Rose Veil': 49021271802039,
        'Cosmic Coral': 49021271834807,
        'Aurora': 48992922337463,
        'Cordelia': 49021271867575,
        'Leo': 49021271900343
      }
    },
    'lash-bond-seal': {
      /* True mono-SKU: offer quantities are not product variants. */
      type: 'single',
      singleTitle: 'Buy 1',
      variantId: 49019726430391
    },
    'surya-test-lash-bond-seal': {
      /* GROUND-UP TRIAL clone of lash-bond-seal (surya-test convention, delete after). */
      type: 'single',
      singleTitle: 'Buy 1',
      variantId: 49096338538679
    },
    'korean-blemish-balm': {
      /* Wave lip/BB 2026-07-24 (clone Cell Fusion C BB) — handle RENOMMÉ korean-blemish-balm le 07-24
         (match nom produit, décision Thomas ; dossiers/fichiers internes restent recovery-skin-tint). Shaded 2, quiz OFF (décision Thomas 07-24,
         2 teintes = quiz inutile). Hex PROVISOIRE-HAO (swatch fournisseur attendu).
         BOGO BxGy: DiscountAutomaticNode/1158462701751. */
      type: 'shaded',
      singleTitle: 'Buy 1 BB Cream',
      shadeHeader: 'Shade',
      defaultShade: 'Signature Beige',
      shades: [
        { name: 'Natural Light', hex: '#E0C0A8' },
        { name: 'Signature Beige', hex: '#D9B59C' }
      ],
      variantIds: {
        'Natural Light': 48924569305271,
        'Signature Beige': 48924569338039
      },
      /* Quiz ON (décision Thomas 2026-07-27, override du "quiz OFF" 07-24) : 6 tone-faces -> 2 shades */
      quiz: { faceShades: ['Natural Light', 'Natural Light', 'Natural Light', 'Signature Beige', 'Signature Beige', 'Signature Beige'] }
    },
    'transfer-proof-lip-vinyl': {
      type: 'shaded',
      b2g3: true,
      defaultOffer: 'b2g3',
      singleTitle: 'Buy 1 Lip Vinyl',
      shadeHeader: 'Shade',
      defaultShade: 'Venus Dune',
      shades: [
        { name: 'Celestial Dust', hex: '#A85671' },
        { name: 'Venus Dune', hex: '#B86878' },
        { name: 'Eclipse Berry', hex: '#7C2847' },
        { name: 'Cosmic Haze', hex: '#8A5E75' },
        { name: 'Petal Comet', hex: '#D77F94' },
        { name: 'Pinkish Dawn', hex: '#D88D9F' }
      ],
      variantIds: {
        'Celestial Dust': 49013753905335,
        'Venus Dune': 49013753938103,
        'Eclipse Berry': 49013753970871,
        'Cosmic Haze': 49013754003639,
        'Petal Comet': 49013754036407,
        'Pinkish Dawn': 49013754069175
      }
    }
  };


  /* Prism supplier connector expansion, 2026-09-10. Product-scoped data only. */
  PRODUCTS['metal-resin-watch-band'].sizeHeader = 'Watch fit';
  PRODUCTS['metal-resin-watch-band'].sizes = ["Small (38–42mm)","Large (44–49mm)","18 mm","20 mm","22 mm","Xiaomi Mi Band 10 Pro / 9 Pro / 8 Pro","Redmi Watch 4 / 5 / 6"];
  PRODUCTS['metal-resin-watch-band'].variantIds = {
    "Rainbow · Rose Gold": {
      "Small (38–42mm)": "49116382888119",
      "Large (44–49mm)": "49116383051959",
      "18 mm": "49143773036727",
      "20 mm": "49143773069495",
      "22 mm": "49143773102263",
      "Xiaomi Mi Band 10 Pro / 9 Pro / 8 Pro": "49143773135031",
      "Redmi Watch 4 / 5 / 6": "49143773167799"
    },
    "Rainbow · Silver": {
      "Small (38–42mm)": "49116383084727",
      "Large (44–49mm)": "49116383117495",
      "18 mm": "49143773200567",
      "20 mm": "49143773233335",
      "22 mm": "49143773266103",
      "Xiaomi Mi Band 10 Pro / 9 Pro / 8 Pro": "49143773298871",
      "Redmi Watch 4 / 5 / 6": "49143773331639"
    },
    "Rainbow · Black": {
      "Small (38–42mm)": "49116383150263",
      "Large (44–49mm)": "49116383183031",
      "18 mm": "49143773364407",
      "20 mm": "49143773397175",
      "22 mm": "49143773429943",
      "Xiaomi Mi Band 10 Pro / 9 Pro / 8 Pro": "49143773462711",
      "Redmi Watch 4 / 5 / 6": "49143773495479"
    },
    "Pearl White · Rose Gold": {
      "Small (38–42mm)": "49116383215799",
      "Large (44–49mm)": "49116383248567",
      "18 mm": "49143773528247",
      "20 mm": "49143773561015",
      "22 mm": "49143773593783",
      "Xiaomi Mi Band 10 Pro / 9 Pro / 8 Pro": "49143773626551",
      "Redmi Watch 4 / 5 / 6": "49143773659319"
    },
    "Pearl White · Silver": {
      "Small (38–42mm)": "49116383281335",
      "Large (44–49mm)": "49116383314103",
      "18 mm": "49143773692087",
      "20 mm": "49143773724855",
      "22 mm": "49143773757623",
      "Xiaomi Mi Band 10 Pro / 9 Pro / 8 Pro": "49143773790391",
      "Redmi Watch 4 / 5 / 6": "49143773823159"
    },
    "Pearl White · Black": {
      "Small (38–42mm)": "49116383346871",
      "Large (44–49mm)": "49116383379639",
      "18 mm": "49143773855927",
      "20 mm": "49143773888695",
      "22 mm": "49143773921463",
      "Xiaomi Mi Band 10 Pro / 9 Pro / 8 Pro": "49143773954231",
      "Redmi Watch 4 / 5 / 6": "49143773986999"
    },
    "Pink & Green · Rose Gold": {
      "Small (38–42mm)": "49116383412407",
      "Large (44–49mm)": "49116383445175",
      "18 mm": "49143774019767",
      "20 mm": "49143774052535",
      "22 mm": "49143774085303",
      "Xiaomi Mi Band 10 Pro / 9 Pro / 8 Pro": "49143774118071",
      "Redmi Watch 4 / 5 / 6": "49143774150839"
    },
    "Pink & Green · Silver": {
      "Small (38–42mm)": "49116383477943",
      "Large (44–49mm)": "49116383510711",
      "18 mm": "49143774183607",
      "20 mm": "49143774216375",
      "22 mm": "49143774249143",
      "Xiaomi Mi Band 10 Pro / 9 Pro / 8 Pro": "49143774281911",
      "Redmi Watch 4 / 5 / 6": "49143774314679"
    },
    "Pink & Green · Black": {
      "Small (38–42mm)": "49116383543479",
      "Large (44–49mm)": "49116383576247",
      "18 mm": "49143774347447",
      "20 mm": "49143774380215",
      "22 mm": "49143774412983",
      "Xiaomi Mi Band 10 Pro / 9 Pro / 8 Pro": "49143774445751",
      "Redmi Watch 4 / 5 / 6": "49143774478519"
    },
    "Blue Floral · Rose Gold": {
      "Small (38–42mm)": "49116383609015",
      "Large (44–49mm)": "49116383641783",
      "18 mm": "49143774511287",
      "20 mm": "49143774544055",
      "22 mm": "49143774576823",
      "Xiaomi Mi Band 10 Pro / 9 Pro / 8 Pro": "49143774609591",
      "Redmi Watch 4 / 5 / 6": "49143774642359"
    },
    "Blue Floral · Silver": {
      "Small (38–42mm)": "49116383674551",
      "Large (44–49mm)": "49116383707319",
      "18 mm": "49143774675127",
      "20 mm": "49143774707895",
      "22 mm": "49143774740663",
      "Xiaomi Mi Band 10 Pro / 9 Pro / 8 Pro": "49143774773431",
      "Redmi Watch 4 / 5 / 6": "49143774806199"
    },
    "Blue Floral · Black": {
      "Small (38–42mm)": "49116383740087",
      "Large (44–49mm)": "49116383772855",
      "18 mm": "49143774838967",
      "20 mm": "49143774871735",
      "22 mm": "49143774904503",
      "Xiaomi Mi Band 10 Pro / 9 Pro / 8 Pro": "49143774937271",
      "Redmi Watch 4 / 5 / 6": "49143774970039"
    },
    "Wood Grain · Rose Gold": {
      "Small (38–42mm)": "49116383805623",
      "Large (44–49mm)": "49116383838391",
      "18 mm": "49143775002807",
      "20 mm": "49143775035575",
      "22 mm": "49143775068343",
      "Xiaomi Mi Band 10 Pro / 9 Pro / 8 Pro": "49143775101111",
      "Redmi Watch 4 / 5 / 6": "49143775133879"
    },
    "Wood Grain · Silver": {
      "Small (38–42mm)": "49116383871159",
      "Large (44–49mm)": "49116383903927",
      "18 mm": "49143775166647",
      "20 mm": "49143775199415",
      "22 mm": "49143775232183",
      "Xiaomi Mi Band 10 Pro / 9 Pro / 8 Pro": "49143775264951",
      "Redmi Watch 4 / 5 / 6": "49143775297719"
    },
    "Wood Grain · Black": {
      "Small (38–42mm)": "49116383936695",
      "Large (44–49mm)": "49116383969463",
      "18 mm": "49143775330487",
      "20 mm": "49143775363255",
      "22 mm": "49143775396023",
      "Xiaomi Mi Band 10 Pro / 9 Pro / 8 Pro": "49143775428791",
      "Redmi Watch 4 / 5 / 6": "49143775461559"
    }
  };
  /* Product renamed 2026-09-06. Keep the old key as a compatibility alias for
     existing templates and the permanent Shopify redirect. */
  PRODUCTS['the-mailbox-slipper'] = PRODUCTS['chestnut-fuzzy-ankle-slippers'];
  PRODUCTS['prism-everyday-watch-band'] = PRODUCTS['metal-resin-watch-band'];

  /* Mosaic colourway swatches — 2026-09-16 follow-up. Product-scoped DATA only, and a
     PURE INSERTION by construction: theme-ops/check-additive-js.sh refuses any removed or
     modified line in this shared file, so the 45 `hex: null` values in the entry above are
     patched here rather than rewritten in place. Same door the Prism supplier expansion
     uses a few lines up. The entry's own PENDING comments are therefore stale-by-design
     until a non-additive maintenance pass collapses them (parity audit D4 records the
     identical situation for the master's sizeHeader).

     WHY IT SHIPPED NULL: `buildPillRow` interpolates `--pill-color:` + s.hex verbatim, so a
     null emitted the literal string "null", which is not a colour — all 45 chips computed
     to the mwb-variant-swap fallback #d8d2cf (measured in the live DOM, PHASE9 §8b).

     SOURCE, and it is an instrument not an eyedropper: the pack's calibrated hex-probe
     table, visuals/mosaic-everyday-watch-band/2026-09-15/working/qc/hex-probes.json —
     _REFERENCES/instruments/hex_probe.py, per-channel MEDIAN (not mean: a patch on a
     glossy convex barrel crosses a highlight) over a hand-placed patch on the centre
     barrel face of a mid-band link, clear of the clasp plate, the lug adapters and the
     watch-case prop. `--calibrate` reproduced 12/12 this session.

     Keyed by NAME, matched 45/45 against the entry above at build time. Only `hex` is
     assigned: no name, id, fit or key is touched, and no other handle is reachable. */
  (function (HEXES) {
    var mwb = PRODUCTS['mosaic-everyday-watch-band'];
    if (!mwb || !mwb.shades) return;
    mwb.shades.forEach(function (s) {
      if (Object.prototype.hasOwnProperty.call(HEXES, s.name)) s.hex = HEXES[s.name];
    });
  }({
    'Tortoiseshell': '#82625F',
    'Rainbow': '#E8917D',
    'Opal White': '#AFA58D',
    'Leopard': '#746562',
    'Smoky Tortoise': '#423834',
    'Forest Tortoise': '#7C726A',
    'Cow Print': '#362C22',
    'Nougat': '#EDE4DC',
    'Chocolate': '#594D4F',
    'Pearl White': '#E9E8E7',
    'White': '#E2E2E2',
    'Ivory Shimmer': '#EEE7DB',
    'Champagne Silk': '#ECD0A9',
    'Lilac Pearl': '#E5DCEF',
    'Powder Pink': '#EFBCB9',
    'Blush Pearl': '#ECDBDB',
    'Petal Pink': '#E4C3BD',
    'Silk Pink': '#A78C7F',
    'Mermaid Pink': '#B691A7',
    'Aurora Pink': '#7E686E',
    'Rose & Mint': '#B2BDAB',
    'Strawberry': '#E99796',
    'Fuchsia': '#CD194F',
    'Sunset': '#E99A95',
    'Black Coral': '#6F534E',
    'Plum Blossom': '#E2AD9A',
    'Merlot': '#5F4352',
    'Ink Violet': '#AEA5A7',
    'Porcelain Blue': '#BAB9BE',
    'Periwinkle': '#9A92B0',
    'Galaxy Blue': '#57677A',
    'Midnight Bloom': '#5E4D59',
    'Pastel Sky': '#CADDE9',
    'Moonlight': '#97AEA4',
    'Ice Blue': '#C6DAE2',
    'Cornflower': '#93B3E3',
    'Emerald': '#547E80',
    'Sea Glass': '#A7AB8E',
    'Peach & Sage': '#F2D0BA',
    'Jade': '#66B75B',
    'Black': '#221E1F',
    'Black Marble': '#4E4E50',
    'Candy Swirl': '#D0BA8C',
    'Amber': '#E1B151',
    'Clear': '#CBCBCD'
  }));
  /* Cleo (cleo-cat-ear-hat) colour rename, REVISIONS A2 2026-10-27 (reviewer comment relayed by Surya: "you can rename
     this color in snow leopard, it will make text shorter"; verbatim in workos visuals/cat-ear-plush-hat/pdp-draft/
     REVISIONS-2026-10-27.md). The store option value becomes "Snow Leopard" in the same release (same variant
     57898364436663, SKU CCH-BWL). PURE INSERTION, the Mosaic-hex door above (check-additive-js.sh refuses a modified
     line): the entry's own "Black-White Leopard" lines stay and are renamed HERE, before getProductConfig() reads
     PRODUCTS just below. Shade name and its variantIds key only; hex #ACAEA9, order and every other shade untouched. */
  (function (FROM, TO) {
    var cch = PRODUCTS['cleo-cat-ear-hat'];
    if (!cch || !cch.shades || !cch.variantIds || !Object.prototype.hasOwnProperty.call(cch.variantIds, FROM)) return;
    cch.shades.forEach(function (s) { if (s.name === FROM) s.name = TO; });
    cch.variantIds[TO] = cch.variantIds[FROM];
    delete cch.variantIds[FROM];
  }('Black-White Leopard', 'Snow Leopard'));

  function getProductConfig() {
    var m = location.pathname.match(/\/products\/([^/?]+)/);
    return m ? (PRODUCTS[m[1]] || null) : null;
  }
  var CFG = getProductConfig();
  // Evidence mode is independent of offer activation. Never inject borrowed
  // proof for a task without eligible review evidence; source gates forbid it.
  var NO_REVIEW_PROOF = CFG && CFG.reviewProofMode === 'no-eligible-corpus';
  /* Mode d'offre = porte serveur (tag Shopify `bogo` -> classe `.adirena-offer-mode`,
     posée dans head.liquid). Un produit garde son entrée PRODUCTS (historique/réactivable)
     mais tant qu'il n'a pas le tag, on ignore la config ici -> pas de sélecteur BOGO injecté,
     le picker natif + le bloc prix natif restent visibles (CSS déjà scopé pareil). Additive :
     n'ajoute qu'une ligne, ne modifie ni ne supprime rien d'existant. */
  if (CFG && !document.documentElement.classList.contains('adirena-offer-mode')) { CFG = null; }

  /* Cover-Cream-compat aliases (only meaningful for type 'shaded') */
  var SHADES = (CFG && CFG.shades) || [];
  var DEFAULT_SHADE = (CFG && CFG.defaultShade) || '';
  var VARIANT_IDS = (CFG && CFG.variantIds) || {};

  /* === AXE TAILLE — produits a DEUX options (Color x Size), 2026-09-02 =======================
     Premier cas du store : chestnut-fuzzy-ankle-slippers (2 coloris x 6 pointures = 12 variantes).
     PORTE DE COMPATIBILITE : tout le bloc est inerte tant que l'entree handle ne declare pas
     `sizes: [...]`. Les 27 handles a une seule option repassent donc par EXACTEMENT le chemin
     d'avant (`SIZES.length === 0` -> aucun rendu, aucun cablage, aucune surcharge panier).
     Design D (arbitrage Surya 2026-09-03, REMPLACE le design C du 2026-09-02) : la taille
     redescend DANS chaque rangee d'unite, a cote des pastilles de coloris de cette meme unite.
     Le design C hissait UNE pointure globale au-dessus des paliers ; la FAQ live de la page
     promet deja « You pick each pair's size and color separately », et deux surfaces de taille
     (une globale + une par unite) auraient fabrique une ambiguite. Une unite = une ligne panier
     = un coloris + une pointure, rien a arbitrer.
     `defaultSize` n'est retenu que s'il appartient reellement a `sizes` : un marqueur MISSING
     (aucun arbitrage merchandising) laisse donc la selection VIDE -> fail closed a l'ajout
     panier, jamais de pointure devinee. */
  var SIZES = (CFG && Array.isArray(CFG.sizes)) ? CFG.sizes : [];
  var SIZE_HEADER = (CFG && CFG.sizeHeader) || 'Size';
  /* Libelle d'OPTION, distinct de `sizeHeader` (Surya 2026-09-03) : `sizeHeader` nomme le
     CONTROLE pour les TECHNOLOGIES D'ASSISTANCE (aria-label), `sizeOptionLabel` nomme la VALEUR
     affichee dans la liste (« US Women 8 ») ET, depuis le 2026-09-04, le placeholder visible
     (cf. SIZE_PLACEHOLDER plus bas). Cle par handle, defaut = SIZE_HEADER -> les 28 autres
     entrees rendent exactement comme avant. Ne touche JAMAIS l'attribut `value` : celui-ci
     reste la cle nue de `variantIds` (resolveSizedVariant/buildSizedItems l'indexent telle
     quelle). */
  var SIZE_OPTION_LABEL = (CFG && CFG.sizeOptionLabel != null) ? CFG.sizeOptionLabel : SIZE_HEADER;
  function sizeOptionText(sz) {
    return SIZE_OPTION_LABEL ? (SIZE_OPTION_LABEL + ' ' + sz) : String(sz);
  }
  /* PLACEHOLDER = l'echelle, pas le mot « Size » (Surya 2026-09-04, « where the fuck is the
     US Women on the sizing options? »). Le defaut fail-closed laisse le controle FERME sur son
     placeholder : une cliente qui n'ouvre jamais la liste ne voyait donc JAMAIS « US Women »,
     alors que les options le portaient depuis le 09-03. L'etat par defaut est le seul etat qui
     compte pour ce defaut. `SIZE_OPTION_LABEL` vaut deja SIZE_HEADER (« Size ») quand aucun
     `sizeOptionLabel` n'est declare -> les 28 autres handles rendent EXACTEMENT comme avant.
     MESURE (playwright, page live, 375px) : « US Women » = 61px de texte contre « US Women 10 »
     = 76px, donc le <select> reste large de 106px et la rangee garde ses 24px de marge — cout
     pixel NUL sur la loi « une seule ligne ». Ne touche jamais l'attribut `value` (vide). */
  /* CLOSED CONTROL READS THE PLAIN OPTION NAME (founder ruling 2026-09-04, explicit):
     "it should be just showing Size, but when i click it then US Women". The placeholder is
     a PROMPT to choose, not a label — the scale belongs on the options the shopper reads
     when the menu is open. An earlier pass put the scale word in the placeholder; that was
     a misread of a complaint about the RING (which then carried no scale anywhere) and it
     is reverted here. Both PDPs are identical on this: closed = "Size", open = "US Women N". */
  var SIZE_PLACEHOLDER = SIZE_HEADER;
  /* NOM ACCESSIBLE du controle — la MEME correction, sur la surface parallele (Surya 2026-09-04).
     Le placeholder visible dit desormais « US Women » pendant que l'aria-label disait encore
     « Size » : WCAG 2.5.3 « Label in Name » exige que le nom accessible CONTIENNE le libelle
     visible, sinon une utilisatrice a la commande vocale ne peut pas viser le controle en
     prononcant ce qu'elle LIT. Corriger une surface et pas sa jumelle est exactement le defaut
     de travail partiel que ce workspace a une loi pour interdire.
     COUT PIXEL NUL : l'aria-label n'est jamais peint, la loi « une seule ligne » ne s'y applique
     pas — donc aucune mesure de largeur n'est en jeu ici.
     Generique : sans `sizeOptionLabel`, les deux constantes sont EGALES -> la chaine reste
     exactement SIZE_HEADER (« Size ») et les 28 autres handles rendent a l'octet pres. */
  function sizeControlName() {
    /* Le nom accessible OUVRE par l'etiquette visible (« Size ») pour satisfaire WCAG 2.5.3
       « Label in Name » — une utilisatrice au controle vocal dit ce qu'elle LIT — puis porte
       l'echelle entre parentheses, que l'oeil ne voit que dans les options. */
    return (!SIZE_OPTION_LABEL || SIZE_OPTION_LABEL === SIZE_HEADER) ? SIZE_HEADER : (SIZE_HEADER + ' (' + SIZE_OPTION_LABEL + ')');
  }
  var DEFAULT_SIZE = (CFG && CFG.defaultSize && SIZES.indexOf(CFG.defaultSize) !== -1) ? CFG.defaultSize : '';

  /* Optional third option. Configuration is bound from real Shopify readback:
     soles[], defaultSole, soleVariantIds[colour][sole][size]. Existing one/two
     option products remain on their original resolver and submit path. */
  var SOLES = (CFG && Array.isArray(CFG.soles)) ? CFG.soles : [];
  var DEFAULT_SOLE = (CFG && SOLES.indexOf(CFG.defaultSole) !== -1) ? CFG.defaultSole : '';

  function existingSoleVariant(colour, sole, size) {
    if (!CFG || !colour || !sole || !size || SOLES.indexOf(sole) === -1 || SIZES.indexOf(size) === -1) return null;
    var byColour = CFG.soleVariantIds && CFG.soleVariantIds[colour];
    var bySole = byColour && byColour[sole];
    var id = bySole && bySole[size];
    // Never accept nested objects, placeholder IDs, or a different sole fallback.
    if (!/^[1-9][0-9]*$/.test(String(id))) return null;
    return id;
  }

  function resolveSoleVariant(colour, sole, size) {
    var id = existingSoleVariant(colour, sole, size);
    if (!id || (CFG.soleVariantAvailability && CFG.soleVariantAvailability[String(id)] === false)) return null;
    return id;
  }

  function unitSoleSelect(key) {
    return document.querySelector('[data-sole-unit="' + key + '"]');
  }

  function unitSoleValue(key) {
    var select = unitSoleSelect(key);
    return select ? select.value : '';
  }

  function soleExists(colour, sole) {
    return SIZES.some(function (size) { return !!existingSoleVariant(colour, sole, size); });
  }

  function clearUnitColour(key) {
    var row = unitShadeRow(key);
    var block = unitSizeBlock(key);
    if (!row) return;
    row.dataset.shadeSelected = '';
    row.querySelectorAll('.adirena-offer__pill').forEach(function (pill) {
      pill.classList.remove('is-selected');
      pill.setAttribute('aria-checked', 'false');
    });
    var caption = row.querySelector('.adirena-offer__pill-caption');
    if (caption && caption.textContent !== 'Color') caption.textContent = 'Color';
    if (block) {
      var select = block.querySelector('[data-size-select]');
      var state = block.querySelector('[data-size-selected]');
      var sizeCaption = block.querySelector('[data-size-caption]');
      if (select) select.value = '';
      if (state) state.dataset.sizeSelected = '';
      if (sizeCaption) sizeCaption.textContent = '';
    }
  }

  function syncUnitColourOptions(key) {
    if (!SOLES.length) return;
    var row = unitShadeRow(key);
    var sole = unitSoleValue(key);
    if (!row) return;
    if (row.dataset.shadeSelected && sole && !soleExists(row.dataset.shadeSelected, sole)) clearUnitColour(key);
    var options = row.querySelectorAll('.ald-dd__opt');
    row.querySelectorAll('.adirena-offer__pill').forEach(function (pill, index) {
      var enabled = !sole || soleExists(pill.dataset.shadeValue, sole);
      if (pill.disabled === enabled) pill.disabled = !enabled;
      var option = options[index];
      if (!option) return; // The existing dropdown is built after the offer.
      if (option.disabled === enabled) option.disabled = !enabled;
      if (option.hidden === enabled) option.hidden = !enabled;
      var display = enabled ? '' : 'none';
      if (option.style.display !== display) option.style.display = display;
      option.classList.toggle('is-selected', pill.dataset.shadeValue === row.dataset.shadeSelected);
    });
    if (!row.dataset.shadeSelected) {
      var label = row.querySelector('.ald-dd__btn span:nth-child(2)');
      var chip = row.querySelector('.ald-dd__btn .ald-dd__chip');
      var button = row.querySelector('.ald-dd__btn');
      if (label && label.textContent !== 'Color') label.textContent = 'Color';
      if (chip && chip.style.background !== 'transparent') chip.style.background = 'transparent';
      if (button && button.getAttribute('aria-label') !== 'Color') button.setAttribute('aria-label', 'Color');
    }
  }

  function notifyUnitVariant(key) {
    var row = unitShadeRow(key);
    if (!row) return;
    var colour = row.dataset.shadeSelected;
    var sole = unitSoleValue(key);
    var size = unitSizeValue(key);
    if (resolveSoleVariant(colour, sole, size)) {
      var block = unitSizeBlock(key);
      var soleSelect = unitSoleSelect(key);
      if (soleSelect) soleSelect.removeAttribute('aria-invalid');
      if (block) {
        block.classList.remove('is-required');
        var state = block.querySelector('[data-size-selected]');
        var caption = block.querySelector('[data-size-caption]');
        if (state) state.removeAttribute('aria-invalid');
        if (caption) caption.textContent = '';
      }
    }
    document.dispatchEvent(new CustomEvent('adirena:unit-variant', { detail: {
      unit: key, colour: colour, sole: sole, size: size,
      variantId: existingSoleVariant(colour, sole, size)
    }}));
  }

  function syncUnitSoleOptions(key) {
    if (!SOLES.length) return;
    var row = unitShadeRow(key);
    var select = unitSoleSelect(key);
    if (!row || !select) return;
    // Sole is the assortment choice. Both source-backed assortments stay
    // reachable even when the current colour belongs to only one of them.
    Array.prototype.forEach.call(select.options, function (option) {
      var enabled = !!option.value && SHADES.some(function (shade) { return soleExists(shade.name, option.value); });
      if (option.disabled === enabled) option.disabled = !enabled;
    });
    if (!Array.prototype.some.call(select.options, function (option) { return option.value === select.value && !option.disabled; })) select.value = '';
    syncUnitColourOptions(key);
  }

  function injectUnitSoleRows() {
    if (!SOLES.length || !SIZES.length) return;
    document.querySelectorAll('[data-adirena-size]').forEach(function (block) {
      var key = block.dataset.sizeUnit;
      if (unitSoleSelect(key)) return;
      var select = document.createElement('select');
      select.className = 'adirena-sole__select';
      select.setAttribute('data-sole-unit', key);
      select.setAttribute('aria-label', 'Sole — ' + key.replace('-', ' '));
      var placeholder = document.createElement('option');
      placeholder.value = ''; placeholder.textContent = 'Sole'; placeholder.disabled = true;
      select.appendChild(placeholder);
      SOLES.forEach(function (sole) {
        var option = document.createElement('option');
        option.value = sole; option.textContent = sole;
        select.appendChild(option);
      });
      select.value = DEFAULT_SOLE;
      block.parentNode.insertBefore(select, block);
      syncUnitSoleOptions(key);
      // Offer labels prevent default clicks; keep native select menus operable.
      select.addEventListener('click', function (event) { event.stopPropagation(); });
      select.addEventListener('change', function () {
        select.removeAttribute('aria-invalid');
        syncUnitSoleOptions(key);
        notifyUnitVariant(key);
      });
      var row = unitShadeRow(key);
      // Dropdowns are created asynchronously by this product's existing snippet.
      // Only child insertion is observed; attribute changes cannot loop this sync.
      new MutationObserver(function () { syncUnitColourOptions(key); }).observe(row, {childList: true});
      row.querySelectorAll('.adirena-offer__pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          // Registered after the existing shade handler; no asynchronous cart race.
          syncUnitSoleOptions(key);
          notifyUnitVariant(key);
        });
      });
      var sizeSelect = block.querySelector('[data-size-select]');
      if (sizeSelect) sizeSelect.addEventListener('change', function () { notifyUnitVariant(key); });
    });
  }
  function buildPillRow(rowAttr) {
    var pills = SHADES.map(function (s) {
      var isDefault = s.name === DEFAULT_SHADE;
      return '<button type="button" class="adirena-offer__pill' + (isDefault ? ' is-selected' : '') + '"' +
             ' style="--pill-color:' + s.hex + '"' +
             ' data-shade-value="' + s.name + '"' +
             ' aria-label="' + s.name + '"' +
             ' aria-checked="' + (isDefault ? 'true' : 'false') + '"' +
             ' role="radio">' +
               '<span class="adirena-offer__pill-check" aria-hidden="true"></span>' +
             '</button>';
    }).join('');
    return '<div class="adirena-offer__pill-row" role="radiogroup" ' + rowAttr +
           ' data-shade-selected="' + DEFAULT_SHADE + '">' +
             pills +
             '<span class="adirena-offer__pill-caption">' + DEFAULT_SHADE + '</span>' +
           '</div>';
  }

  /* === PALIER B2G3 (test 2026-07-30) — « payer 2, recevoir 5 » ===
     GÉNÉRIQUE : rendu uniquement si `cfg.b2g3 === true` (clé de config par handle, cf. Règle #2 :
     aucune logique par SKU dans ce fichier partagé). Le discount Shopify BxGy correspondant
     (buy 2 → get 3 à -100%) fait le prix ; ce bloc ne fait que l'UI + envoyer 5 lignes au panier.
     Vérifié en réel le 2026-07-30 : les 2 BxGy coexistent, Shopify applique le meilleur des deux
     (2u → BOGO, 5u → B2G3), y compris avec 5 teintes différentes.
     Badge « Labor Day Sale » AUSSI sur cette ligne (Thomas 2026-08-03) — le CSS doit alors porter
     `position: relative` sur .adirena-offer--b2g3, sinon le badge s'échappe vers le haut de page. */
  var B2G3_UNITS = 5;      /* ce que la cliente reçoit */
  var B2G3_PAID_UNITS = 2; /* ce qu'elle paie */

  /* Lignes panier du palier B2G3 : on envoie B2G3_UNITS unités, le discount BxGy
     « buy 2 → get 3 » n'en facture que 2. Mono-SKU = N× la variante ; teinté = une ligne
     par pastille (rangées data-b2g3-shade), avec repli sur la teinte par défaut. */
  function buildB2G3Items() {
    if (!CFG || !CFG.b2g3) return null;
    if (CFG.type === 'single') return [{ id: CFG.variantId, quantity: B2G3_UNITS }];
    var out = [];
    for (var bi = 1; bi <= B2G3_UNITS; bi++) {
      var bRow = document.querySelector('[data-b2g3-shade="' + bi + '"]');
      var bId = VARIANT_IDS[(bRow && bRow.dataset.shadeSelected) || DEFAULT_SHADE];
      if (bId) out.push({ id: bId, quantity: 1 });
    }
    return out.length ? out : null;
  }

  function buildB2G3HTML(cfg, hdr) {
    if (!cfg.b2g3) return '';
    var rows = '';
    if (cfg.type !== 'single') {
      for (var i = 1; i <= B2G3_UNITS; i++) {
        rows += '<div class="adirena-offer__shade-row">' +
                  '<span class="adirena-offer__shade-label">' + (cfg.unitLabel || 'Stick') + ' ' + i + '</span>' +
                  buildPillRow('data-b2g3-shade="' + i + '"') +
                '</div>';
      }
      rows = '<div class="adirena-offer__shades">' +
               '<div class="adirena-offer__shade-block">' +
                 '<span class="adirena-offer__shade-header">' + hdr + '</span>' + rows +
               '</div>' +
             '</div>';
    }
    return '<label class="adirena-offer adirena-offer--b2g3" data-offer="b2g3">' +
             '<span class="adirena-offer__badge">Halloween Sale</span>' +  /* Thomas 2026-08-03 : badge AUSSI sur B2G3 */
             '<span class="adirena-offer__radio"></span>' +
             '<div class="adirena-offer__main">' +
               '<div class="adirena-offer__title-row"><span class="adirena-offer__title">Buy 2, Get 3 Free</span></div>' +
             '</div>' +
             '<div class="adirena-offer__price"><strong data-adirena-price="b2g3">$--.--</strong>' +
               '<s data-adirena-price="b2g3-strike">$--.--</s></div>' +
             rows +
           '</label>';
  }


  /* === CONTROLE DE TAILLE PAR UNITE (design D, 2026-09-03) ===================================
     REMPLACE le selecteur global du design C (2026-09-02). UN controle de taille par LIGNE
     PANIER, injecte a cote des pastilles de coloris de SON unite : une unite = un coloris + une
     pointure. Rendu DANS le palier, donc visible seulement quand ce palier est selectionne,
     exactement comme les coloris.
     TECHNIQUE ADDITIVE conservee : `buildPillRow`, `buildOfferSelectorHTML` et `buildB2G3HTML`
     ne sont pas touches — les blocs de taille sont injectes APRES coup a cote de chaque rangee
     de coloris, comme le palier B2G3 l'est lui-meme. La porte de compatibilite reste
     `!SIZES.length` : sans `sizes`, rien n'est rendu, rien n'est cable, le panier est intact.
     Classe VOLONTAIREMENT distincte (`adirena-size__pill`, pas `adirena-offer__pill`) : une
     pastille de POINTURE porte un chiffre, et le pont mobile `xfs-variant-swap` (qui masque
     `.adirena-offer__pill` sous 750px pour les remplacer par un dropdown de coloris) ne doit
     surtout pas l'attraper. */

  /* Cle d'unite LUE SUR LA RANGEE DE COLORIS elle-meme : seul endroit ou l'appartenance d'un
     controle de taille a une ligne panier est etablie. `ultimate` renvoie '' — ce palier resout
     un SKU bundle, pas une combinaison coloris x pointure, donc aucune taille a offrir. */
  function sizeUnitKey(row) {
    if (!row) return '';
    if (row.hasAttribute('data-single-shade')) return 'single';
    var b = row.getAttribute('data-bogo-shade');
    if (b) return 'bogo-' + b;
    var g = row.getAttribute('data-b2g3-shade');
    if (g) return 'b2g3-' + g;
    return '';
  }

  /* Chemin inverse : la rangee de coloris d'une unite donnee. */
  function unitShadeRow(unitKey) {
    if (unitKey === 'single') return document.querySelector('[data-single-shade]');
    var n = unitKey.slice(unitKey.lastIndexOf('-') + 1);
    if (unitKey.indexOf('bogo-') === 0) return document.querySelector('[data-bogo-shade="' + n + '"]');
    if (unitKey.indexOf('b2g3-') === 0) return document.querySelector('[data-b2g3-shade="' + n + '"]');
    return null;
  }

  function unitSizeBlock(unitKey) {
    return document.querySelector('[data-adirena-size][data-size-unit="' + unitKey + '"]');
  }

  function unitSizeValue(unitKey) {
    var block = unitSizeBlock(unitKey);
    var srow = block && block.querySelector('[data-size-selected]');
    return (srow && srow.dataset.sizeSelected) || DEFAULT_SIZE || '';
  }

  /* Un bloc de taille par unite. `sub` = l'unite porte deja une etiquette (« Pair 1 ») dans une
     `.adirena-offer__shade-row` ; le bloc est alors indente sous elle (CSS `adirena-size--sub`). */
  function buildUnitSizeHTML(unitKey, unitName, sub) {
    if (!SIZES.length) return '';
    var suffix = unitName ? ' — ' + unitName : '';
    /* SELECT compact (arbitrage Surya 2026-09-03, « selective option ») : six pastilles par
       unite noyaient la rangee sur mobile (86px de pastilles a cote du dropdown de coloris du
       pont xfs-variant-swap). UN <select> natif par unite, meme grammaire que le dropdown de
       coloris mobile, coherent desktop/mobile. Le contrat du bloc ne change pas :
       [data-size-selected] porte la valeur, vide = fail closed. */
    var opts = '<option value=""' + (DEFAULT_SIZE ? '' : ' selected') + ' disabled>' +
                 SIZE_PLACEHOLDER + '</option>' +
      SIZES.map(function (sz) {
        return '<option value="' + sz + '"' + (sz === DEFAULT_SIZE ? ' selected' : '') + '>' +
               sizeOptionText(sz) + '</option>';
      }).join('');
    return '<div class="adirena-size adirena-size--unit' + (sub ? ' adirena-size--sub' : '') + '"' +
             ' data-adirena-size data-size-unit="' + unitKey + '">' +
             '<span class="adirena-size__row" data-size-selected="' + DEFAULT_SIZE + '">' +
               '<select class="adirena-size__select" data-size-select' +
                 ' aria-label="' + sizeControlName() + suffix + '">' + opts + '</select>' +
             '</span>' +
             '<span class="adirena-size__caption" data-size-caption></span>' +
           '</div>';
  }

  /* Injection : un bloc apres CHAQUE rangee de coloris portant une cle d'unite. Idempotent, et
     inerte sans `sizes`. Les rangees `ultimate` sont ignorees (cle vide). */
  function injectUnitSizeRows() {
    if (!SIZES.length) return;
    var selector = document.querySelector('.adirena-offer-selector');
    if (!selector) return;
    selector.querySelectorAll('.adirena-offer__pill-row').forEach(function (row) {
      var key = sizeUnitKey(row);
      if (!key || unitSizeBlock(key)) return;
      var parent = row.parentNode;
      var labelled = !!(parent && parent.classList && parent.classList.contains('adirena-offer__shade-row'));
      var anchor = labelled ? parent : row;
      var labelEl = labelled ? anchor.querySelector('.adirena-offer__shade-label') : null;
      /* UNE SEULE LIGNE (arbitrage Surya 2026-09-03) : le select de pointure vit DANS la
         rangee de coloris (flex, margin-left:auto le pousse a droite), plus jamais une
         deuxieme ligne sous elle. Le contrat [data-size-*] ne bouge pas. */
      anchor.insertAdjacentHTML('beforeend', buildUnitSizeHTML(key, labelEl ? labelEl.textContent : '', labelled));
    });
  }

  /* Unites dont la ligne panier n'a pas resolu au dernier essai d'ajout. */
  var SIZE_MISSING_UNITS = [];

  /* Etat visible « il manque la pointure », POSE SUR L'UNITE FAUTIVE (design C ne pouvait
     designer que le bloc global). Aucun prix, aucune ligne panier n'est inventee. */
  function flagSizeRequired() {
    var first = null;
    for (var mi = 0; mi < SIZE_MISSING_UNITS.length; mi++) {
      var key = SIZE_MISSING_UNITS[mi];
      var block = unitSizeBlock(key);
      if (!block) continue;
      block.classList.add('is-required');
      var chosen = unitSizeValue(key);
      var cap = block.querySelector('[data-size-caption]');
      /* La legende nomme la pointure AVEC son libelle affiche (« Not available in US Women 7 ») :
         `chosen` est la valeur nue, jamais montree telle quelle a la cliente. */
      if (cap) cap.textContent = chosen ? ('Not available in ' + sizeOptionText(chosen)) : 'Choose your size';
      if (SOLES.length) {
        var soleSelect = unitSoleSelect(key);
        if (soleSelect && !soleSelect.value) {
          soleSelect.setAttribute('aria-invalid', 'true');
          if (cap) cap.textContent = 'Choose your sole';
        } else if (cap && chosen) cap.textContent = 'This colour, sole and size is unavailable';
      }
      var srow = block.querySelector('[data-size-selected]');
      if (srow) srow.setAttribute('aria-invalid', 'true');
      if (!first) first = block;
    }
    if (first && first.scrollIntoView) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /* Resolution a DEUX cles -> id de variante, ou null (fail closed). La pointure est lue sur le
     bloc de CETTE unite, plus sur une rangee globale.
     `!SIZES.length` est LA porte de compatibilite : les SKU a une option ressortent par
     l'indexation simple, valeur pour valeur (nombre OU chaine, cf. crystal-spinner-anxiety-ring). */
  function resolveSizedVariant(colour, unitKey) {
    if (SOLES.length) return resolveSoleVariant(colour, unitSoleValue(unitKey), unitSizeValue(unitKey));
    var byColour = VARIANT_IDS[colour || DEFAULT_SHADE];
    if (!byColour) return null;
    if (!SIZES.length) return byColour;
    var size = unitSizeValue(unitKey);
    if (!size) return null;                        /* aucune pointure choisie -> fail closed */
    var vid = byColour[size];
    return (vid === 0 || vid) ? vid : null;        /* combinaison inconnue -> fail closed */
  }

  /* Lignes panier du palier courant, RE-DERIVEES unite par unite depuis SA rangee de coloris et
     SON bloc de taille. Tout ou rien : une seule unite non resolue annule l'ajout (meme doctrine
     que le palier `ultimate`, Codex BLOCKER 2) — on ne poste JAMAIS un `id` absent, qui repartait
     en 4xx sur /cart/add.js et tuait le bouton sur TOUS les paliers. */
  function buildSizedItems() {
    if (!SIZES.length || !CFG) return null;
    if (CFG.type === 'single') return null;        /* config incoherente : sizes exige des coloris */
    var units = [];
    if (currentOffer === 'b2g3' && CFG.b2g3) {
      for (var si = 1; si <= B2G3_UNITS; si++) units.push('b2g3-' + si);
    } else if (currentOffer === 'bogo') {
      units.push('bogo-1');
      units.push('bogo-2');
    } else {
      units.push('single');
    }
    var sout = [];
    var missing = [];
    for (var ui = 0; ui < units.length; ui++) {
      var crow = unitShadeRow(units[ui]);
      var svid = resolveSizedVariant(crow && crow.dataset.shadeSelected, units[ui]);
      if (svid) sout.push({ id: svid, quantity: 1 });
      else missing.push(units[ui]);
    }
    SIZE_MISSING_UNITS = missing;
    if (missing.length) return null;
    return sout.length ? sout : null;
  }

  /* Cablage des pastilles de taille : meme grammaire que les coloris (selection + caption +
     aria), mais sur LA rangee de son unite, et idempotent (`adirenaSizeHooked`). */
  function wireSizeRows() {
    document.querySelectorAll('[data-adirena-size]').forEach(function (block) {
      if (block.dataset.adirenaSizeHooked === '1') return;
      var srow = block.querySelector('[data-size-selected]');
      if (!srow) return;
      block.dataset.adirenaSizeHooked = '1';
      var caption = block.querySelector('[data-size-caption]');
      var select = block.querySelector('[data-size-select]');
      if (!select) return;
      select.addEventListener('change', function () {
        var value = select.value || '';
        srow.dataset.sizeSelected = value;
        if (value) {
          srow.removeAttribute('aria-invalid');
          block.classList.remove('is-required');
          if (caption) caption.textContent = '';
        }
      });
    });
  }
  /* === PALIER ULTIMATE (net-new 2026-08-13) — bundle multi-produits a prix fixe ================
     GENERIQUE : rendu uniquement si `cfg.ultimate.cartMode === 'bundle_variant'` (config par handle,
     regle #2). Contrairement a single/bogo/b2g3, AUCUNE remise Shopify n'intervient : le prix affiche
     est le prix de la variante bundle. Le gel, le pen, la pince et le gift sont inclus dans le SKU
     bundle (picking HAO), pas en lignes panier.
     FAIL CLOSED (Codex BLOCKER 2) : tant que le bundle n'est pas charge ET valide, le palier reste
     non selectionnable ; si la combinaison de teintes ne resout pas un SKU connu, on n'envoie RIEN
     au panier. Aucun repli sur une autre variante ni sur le tint standard. */
  var ULT = { ready: false, bySku: {}, priceCents: null, strikeCents: null, failed: false };

  function ultimateCfg() {
    var u = CFG && CFG.ultimate;
    return (u && u.cartMode === 'bundle_variant' && u.handle && u.shadeCodes) ? u : null;
  }

  /* Cle canonique = codes de teinte TRIES puis concatenes -> SKU. Robuste au renommage/traduction
     et a l'ordre de selection (Espresso+Taupe et Taupe+Espresso donnent le meme SKU). */
  function ultimateResolveSku() {
    var u = ultimateCfg(); if (!u) return null;
    var codes = [];
    for (var i = 1; i <= u.shadeCount; i++) {
      var row = document.querySelector('[data-ultimate-shade="' + i + '"]');
      /* CORRECTIF Codex ultra 2026-08-13 (BLOCKER) : PAS de repli sur DEFAULT_SHADE. Une rangee
         absente ou vide devenait silencieusement "Taupe" -> la cliente payait $39.97 pour une paire
         qu'elle n'avait pas choisie. Rangee absente = fail closed, comme une teinte inconnue. */
      var shade = row && row.dataset.shadeSelected;
      if (!shade) return null;
      var code = u.shadeCodes[shade];
      if (!code) return null;              /* teinte inconnue -> fail closed */
      codes.push(code);
    }
    if (codes.length !== u.shadeCount) return null;
    return u.skuPrefix + codes.sort().join('');
  }

  /* Ensemble EXACT des SKU attendus, derive des codes de teinte (toutes les paires triees).
     CORRECTIF Codex ultra (BLOCKER) : compter 10 variantes ne prouve pas que ce sont LES 10 bonnes. */
  function ultimateExpectedSkus() {
    var u = ultimateCfg(); if (!u || u.shadeCount !== 2) return null;
    var codes = Object.keys(u.shadeCodes).map(function (k) { return u.shadeCodes[k]; }).sort();
    var out = [];
    for (var a = 0; a < codes.length; a++) {
      for (var b = a; b < codes.length; b++) out.push(u.skuPrefix + [codes[a], codes[b]].sort().join(''));
    }
    return out;
  }

  function ultimateFetchBundle() {
    var u = ultimateCfg(); if (!u) return;
    fetch('/products/' + u.handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('bundle ' + r.status); return r.json(); })
      .then(function (p) {
        var vs = (p && p.variants) || [];
        vs.forEach(function (v) { if (v.sku) ULT.bySku[v.sku] = v; });
        /* CORRECTIF Codex ultra (BLOCKER) : valider l'ensemble EXACT, pas un simple compte.
           On exige les 10 SKU attendus, tous achetables, tous au MEME prix. Sinon fail closed. */
        var expected = ultimateExpectedSkus() || [];
        if (expected.length !== u.expectedVariants) throw new Error('cfg teintes incoherente');
        var price = null;
        for (var i = 0; i < expected.length; i++) {
          var v = ULT.bySku[expected[i]];
          if (!v || !v.id) throw new Error('SKU manquant ' + expected[i]);
          if (v.available === false) throw new Error('SKU indisponible ' + expected[i]);
          if (price === null) price = v.price;
          else if (v.price !== price) throw new Error('prix non uniforme sur ' + expected[i]);
        }
        var first = ULT.bySku[expected[0]];
        ULT.priceCents = price;
        ULT.strikeCents = first.compare_at_price || null;
        ULT.ready = true;
        /* CORRECTIF Codex ultra (BLOCKER « prix trompeur ») : renseigner la table que selectOffer()
           utilise pour verrouiller le prix du bouton ATC et de la barre collante. Sans ca, le palier
           affichait $39.97 pendant que la barre restait a $19.97 et que le panier debitait $39.97. */
        OFFER_PRICES.ultimate = formatMoney(ULT.priceCents);
        ultimateSyncUI();
        ultimateSyncPriceHosts();
      })
      .catch(function (e) {
        ULT.failed = true;
        console.error('[Adirena ultimate] bundle indisponible —', e.message);
        ultimateSyncUI();
      });
  }

  /* Etat visible du palier : en attente / indisponible / pret. Aucun prix invente. */
  function ultimateSyncUI() {
    var row = document.querySelector('[data-offer="ultimate"]'); if (!row) return;
    var priceEl = row.querySelector('[data-adirena-price="ultimate"]');
    var strikeEl = row.querySelector('[data-adirena-price="ultimate-strike"]');
    var noteEl = row.querySelector('[data-ultimate-note]');
    row.classList.toggle('is-unavailable', !ULT.ready);
    if (ULT.ready) {
      if (priceEl) priceEl.textContent = formatMoney(ULT.priceCents);
      if (strikeEl && ULT.strikeCents) strikeEl.textContent = formatMoney(ULT.strikeCents);
      if (noteEl) noteEl.textContent = '';
      /* Pastille SAVE calculee depuis les MEMES cents que le prix affiche et que le panier.
         Masquee tant qu'il n'y a pas de barre exploitable — jamais de « SAVE $0 » ni de valeur devinee. */
      var saveEl = row.querySelector('[data-ultimate-save]');
      if (saveEl) {
        var delta = (ULT.strikeCents != null && ULT.priceCents != null)
          ? (Number(ULT.strikeCents) - Number(ULT.priceCents)) : 0;
        if (delta > 0) { saveEl.textContent = 'SAVE ' + formatMoney(delta); saveEl.hidden = false; }
        else { saveEl.hidden = true; }
      }
    } else if (ULT.failed) {
      if (noteEl) noteEl.textContent = 'Temporarily unavailable';
      /* CORRECTIF Codex ultra : on NE rappelle PAS selectOffer() ici — elle est declaree dans la
         portee de l'init, pas au niveau module : l'appel levait un ReferenceError qui aurait avale
         le reste de la fonction. On rabat la selection via un clic sur la ligne BOGO, qui passe par
         le cablage generique existant. `is-unavailable` (pointer-events:none) empeche deja tout
         nouvel achat sur le palier casse. */
      if (currentOffer === 'ultimate') {
        var fallback = document.querySelector('[data-offer="bogo"]') || document.querySelector('[data-offer="single"]');
        if (fallback) fallback.click();
      }
    }
  }

  /* Verrouille le prix du palier courant sur les DEUX surfaces d'achat (bouton ATC + barre collante).
     CORRECTIF Codex ultra (BLOCKER « prix trompeur »). Le bloc equivalent existant ne tourne QUE si
     `CFG.defaultOffer` est defini — ce n'est pas notre cas, d'ou la barre restee a $19.97.
     Scope : uniquement les pages portant une config `ultimate` -> blast radius nul ailleurs. */
  function ultimateSyncPriceHosts() {
    if (!ultimateCfg()) return;
    var want = OFFER_PRICES[currentOffer];
    if (!want || want.indexOf('--') !== -1) return;
    [document.querySelector('[data-add-to-cart-text]'), document.querySelector('.cart-bar')]
      .filter(Boolean)
      .forEach(function (host) {
        var el = host.querySelector('[data-product-price]');
        if (el && el.dataset.adirenaLockedPrice !== want) {
          el.dataset.adirenaLockedPrice = want;
          el.textContent = want;
        }
      });
  }

  function buildUltimateItems() {
    var u = ultimateCfg(); if (!u || !ULT.ready) return null;
    var sku = ultimateResolveSku(); if (!sku) return null;
    var v = ULT.bySku[sku];
    if (!v || !v.id) return null;          /* combinaison inconnue -> fail closed, aucun repli */
    return [{ id: v.id, quantity: u.bundleQuantity || 1 }];
  }

  function buildUltimateHTML(cfg, hdr) {
    var u = cfg.ultimate;
    if (!u || u.cartMode !== 'bundle_variant') return '';
    var rows = '';
    for (var i = 1; i <= u.shadeCount; i++) {
      rows += '<div class="adirena-offer__shade-row">' +
                '<span class="adirena-offer__shade-label">' + (cfg.unitLabel || 'Tube') + ' ' + i + '</span>' +
                buildPillRow('data-ultimate-shade="' + i + '"') +
              '</div>';
    }
    /* Pile de valeur (modele Smooche) : une ligne par cadeau, vignette produit + « + FREE X » +
       prix barre. Rendue en PERMANENCE (pas seulement quand le palier est selectionne) — c'est
       elle qui vend le palier. Aucun montant en dur ici : tout vient de `u.includes`. */
    var incs = (u.includes || []).map(function (it) {
      var thumb = it.img
        ? '<img class="adirena-offer__inc-img" src="' + it.img + '" alt="" loading="lazy" width="24" height="24">'
        : '<span class="adirena-offer__inc-dot" aria-hidden="true"></span>';
      var val = (it.value != null) ? '<s class="adirena-offer__inc-value">' + formatMoney(it.value) + '</s>' : '';
      return '<li class="adirena-offer__inc">' + thumb +
               '<span class="adirena-offer__inc-label">' +
                 '<span class="adirena-offer__inc-free">+ FREE</span> ' + it.label +
               '</span>' + val +
             '</li>';
    }).join('');

    return '<label class="adirena-offer adirena-offer--ultimate is-unavailable" data-offer="ultimate">' +
             /* "Best Value" — SUPERSEDE la decision du 2026-08-13 (« pas de pastille Best Value a
                part, on garde Labor Day Sale »). Thomas 2026-08-14 : ce palier doit se distinguer des
                deux autres, qui gardent "Labor Day Sale".
                ⚠️ CLASSE VOLONTAIREMENT DIFFERENTE : `__tier`, PAS `__badge`. check-offer-sync.sh
                exige que tout `.adirena-offer__badge` vaille le BADGE_LABEL canonique ("Labor Day
                Sale") — c'est ce qui empeche un badge de raconter une autre offre que l'annonce du
                header (incident 2026-06-06), et `_OFFER-CANONICAL.md` interdit nommement "Best
                value" comme label d'OFFRE. Ce libelle-ci n'annonce aucune offre : il hierarchise
                les paliers. Il a donc sa propre classe, le gate reste intact et mordant, et aucune
                exception n'a ete ajoutee au garde-fou. Style : `.adirena-offer__tier` (CSS). */
             '<span class="adirena-offer__tier">Best Value</span>' +
             '<span class="adirena-offer__radio"></span>' +
             '<div class="adirena-offer__main">' +
               '<div class="adirena-offer__title-row"><span class="adirena-offer__title">' + u.title + '</span></div>' +
               '<span class="adirena-offer__blurb">' + u.blurb + '</span>' +
               '<span class="adirena-offer__note" data-ultimate-note></span>' +
             '</div>' +
             '<div class="adirena-offer__price"><strong data-adirena-price="ultimate">$--.--</strong>' +
               '<s data-adirena-price="ultimate-strike">$--.--</s>' +
               /* SAVE — CALCULE (barre moins prix) dans ultimateSyncUI, jamais ecrit en dur.
                  Range avec les prix pour garder toute la promesse de valeur dans une seule pile,
                  y compris sur mobile ou le titre prenait auparavant toute la largeur disponible. */
               '<span class="adirena-offer__save" data-ultimate-save hidden></span></div>' +
             (incs ? '<ul class="adirena-offer__includes">' + incs + '</ul>' : '') +
             '<div class="adirena-offer__shades"><div class="adirena-offer__shade-block">' +
               '<span class="adirena-offer__shade-header">' + hdr + '</span>' + rows +
             '</div></div>' +
           '</label>';
  }

  function buildOfferSelectorHTML(cfg) {
    /* Single-SKU masks: Buy 1 / Buy 1 Get 1 Free, no shade pills */
    if (cfg.type === 'single') {
      /* CLE DE CONFIG `noBogo` (2026-08-25, decision Thomas — retrait BOGO Cover Cream/CFS,
         fulfillment 2u bloque) : logique GENERIQUE (regle #2), un produit sans offre BOGO
         n'affiche que le palier single et reste selectionne dessus. */
      return '<div class="adirena-offer-selector adirena-offer-selector--single">' +
        '<label class="adirena-offer" data-offer="single">' +
          '<span class="adirena-offer__radio"></span>' +
          '<div class="adirena-offer__main">' +
            '<div class="adirena-offer__title-row"><span class="adirena-offer__title">' + cfg.singleTitle + '</span></div>' +
          '</div>' +
          '<div class="adirena-offer__price"><strong data-adirena-price="single">$--.--</strong></div>' +
        '</label>' +
        (cfg.noBogo ? '' :
        '<label class="adirena-offer adirena-offer--bogo" data-offer="bogo">' +
          '<span class="adirena-offer__badge">Halloween Sale</span>' +
          '<span class="adirena-offer__radio"></span>' +
          '<div class="adirena-offer__main">' +
            '<div class="adirena-offer__title-row"><span class="adirena-offer__title">Buy 1, Get 1 Free</span></div>' +
          '</div>' +
          '<div class="adirena-offer__price"><strong data-adirena-price="bogo">$--.--</strong><s data-adirena-price="bogo-strike">$--.--</s></div>' +
        '</label>') +
      '</div>';
    }
    /* Shaded (e.g. Second Skin): multi-variant with skin-tone pills */
    var hdr = cfg.shadeHeader || 'Shade';
    return '<div class="adirena-offer-selector">' +
      '<label class="adirena-offer" data-offer="single">' +
        '<span class="adirena-offer__radio"></span>' +
        '<div class="adirena-offer__main">' +
          '<div class="adirena-offer__title-row"><span class="adirena-offer__title">' + cfg.singleTitle + '</span></div>' +
        '</div>' +
        '<div class="adirena-offer__price"><strong data-adirena-price="single">$--.--</strong></div>' +
        '<div class="adirena-offer__shades">' +
          '<div class="adirena-offer__shade-block">' +
            '<span class="adirena-offer__shade-header">' + hdr + '</span>' +
            buildPillRow('data-single-shade') +
          '</div>' +
        '</div>' +
      '</label>' +
      '<label class="adirena-offer adirena-offer--bogo" data-offer="bogo">' +
        '<span class="adirena-offer__badge">Halloween Sale</span>' +
        '<span class="adirena-offer__radio"></span>' +
        '<div class="adirena-offer__main">' +
          '<div class="adirena-offer__title-row"><span class="adirena-offer__title">Buy 1, Get 1 Free</span></div>' +
        '</div>' +
        '<div class="adirena-offer__price"><strong data-adirena-price="bogo">$--.--</strong><s data-adirena-price="bogo-strike">$--.--</s></div>' +
        '<div class="adirena-offer__shades">' +
          '<div class="adirena-offer__shade-block">' +
            '<span class="adirena-offer__shade-header">' + hdr + '</span>' +
            '<div class="adirena-offer__shade-row">' +
              '<span class="adirena-offer__shade-label">' + (cfg.unitLabel || 'Stick') + ' 1</span>' +
              buildPillRow('data-bogo-shade="1"') +
            '</div>' +
            '<div class="adirena-offer__shade-row">' +
              '<span class="adirena-offer__shade-label">' + (cfg.unitLabel || 'Stick') + ' 2</span>' +
              buildPillRow('data-bogo-shade="2"') +
            '</div>' +
          '</div>' +
        '</div>' +
      '</label>' +
    '</div>';
  }

  var OFFER_PRICES = { 'single': '$--.--', 'bogo': '$--.--' };
  var currentOffer = (typeof CFG !== 'undefined' && CFG && CFG.noBogo) ? 'single' : 'bogo';

  /* === Dynamic price — read from Shopify variant, no hardcode === */
  /* Currency symbol/suffix captured from the same localized Palo Alto price element
     the amount is read from (Markets: £/A$/C$/NZ$...) — '$' only as last-resort default. */
  var MONEY_FORMAT = { prefix: '$', suffix: '' };
  function formatMoney(cents) {
    var suffix = MONEY_FORMAT.suffix ? ' ' + MONEY_FORMAT.suffix : '';
    return MONEY_FORMAT.prefix + (cents / 100).toFixed(2) + suffix;
  }
  function readDOMPriceCents() {
    /* Source of truth = Palo Alto's own price element, server-rendered with current variant price.
       The ATC-scoped element disappeared from newer templates — fall back to the page's
       [data-product-price] (same product, Markets-localized symbol included). */
    var el = document.querySelector('[data-add-to-cart-text] [data-product-price]') ||
             document.querySelector('[data-product-price]');
    if (!el) return null;
    var raw = (el.textContent || '').trim();
    var m = raw.match(/[\d,]+\.?\d*/);
    if (!m) return null;
    var prefix = raw.slice(0, m.index).trim();
    var suffix = raw.slice(m.index + m[0].length).trim();
    if (prefix || suffix) { MONEY_FORMAT.prefix = prefix; MONEY_FORMAT.suffix = suffix; }
    var num = parseFloat(m[0].replace(/,/g, ''));
    return isNaN(num) ? null : Math.round(num * 100);
  }
  function fetchVariantPriceCents() {
    var match = location.pathname.match(/\/products\/([^/?]+)/);
    if (!match) return Promise.resolve(null);
    return fetch('/products/' + match[1] + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.variants || !data.variants.length) return null;
        return data.variants[0].price; /* already in cents */
      })
      .catch(function () { return null; });
  }
  function applyDynamicPrices(unitCents) {
    if (!unitCents) return;
    var single = formatMoney(unitCents);
    var strike = formatMoney(unitCents * 2);
    document.querySelectorAll('[data-adirena-price="single"], [data-adirena-price="bogo"]').forEach(function (el) {
      el.textContent = single;
    });
    document.querySelectorAll('[data-adirena-price="bogo-strike"]').forEach(function (el) {
      el.textContent = strike;
    });
    OFFER_PRICES.single = single;
    OFFER_PRICES.bogo = single;
    /* Palier B2G3 (test 2026-07-30) : la cliente PAIE 2 unités et en REÇOIT 5.
       Même source de vérité que les autres lignes (prix variante live, jamais de montant en dur)
       → reste juste sur tous les marchés Shopify Markets et à chaque changement de prix. */
    var b2g3Paid = formatMoney(unitCents * B2G3_PAID_UNITS);
    var b2g3Strike = formatMoney(unitCents * B2G3_UNITS);
    document.querySelectorAll('[data-adirena-price="b2g3"]').forEach(function (el) {
      el.textContent = b2g3Paid;
    });
    document.querySelectorAll('[data-adirena-price="b2g3-strike"]').forEach(function (el) {
      el.textContent = b2g3Strike;
    });
    OFFER_PRICES.b2g3 = b2g3Paid;
    /* Re-lock ATC display if already wired */
    document.querySelectorAll('[data-add-to-cart-text] [data-product-price]').forEach(function (el) {
      if (el.dataset.adirenaLockedPrice) {
        el.dataset.adirenaLockedPrice = single;
        el.textContent = single;
      }
    });
  }

  function injectOfferSelector(scope) {
    if (!CFG) return; /* unknown product → don't inject (avoids wrong selector) */
    var form = scope.querySelector('.product__form__wrapper');
    if (!form || form.dataset.adirenaOfferInjected === '1') return;

    form.insertAdjacentHTML('beforebegin', buildOfferSelectorHTML(CFG));
    form.dataset.adirenaOfferInjected = '1';
    /* 3e palier B2G3 — ajouté APRÈS coup (et non dans buildOfferSelectorHTML) pour garder le
       diff de ce fichier partagé PUREMENT ADDITIF : le gate check-additive-js.sh refuse toute
       ligne modifiée ici (incident BOGO CC 2026-07-10). Inséré avant le câblage ci-dessous,
       donc les listeners génériques (offres + pastilles) le prennent automatiquement. */
    if (CFG.b2g3) {
      var b2g3Host = document.querySelector('.adirena-offer-selector');
      if (b2g3Host) b2g3Host.insertAdjacentHTML('beforeend', buildB2G3HTML(CFG, CFG.shadeHeader || 'Shade'));
    }

    /* Controles de TAILLE (design D, 2026-09-03) — un par unite, colle aux pastilles de coloris
       de cette unite, meme technique additive que le B2G3 ci-dessus : injecte AVANT le cablage,
       donc les listeners generiques le voient. Inerte sans `sizes`. */
    injectUnitSizeRows();

    /* Palier ULTIMATE — meme technique additive que le B2G3 ci-dessus : injecte AVANT le cablage,
       donc les listeners generiques (selection d'offre + pastilles de teinte) le prennent seuls.
       Rendu desactive (`is-unavailable`) ; il ne s'active qu'apres validation du bundle. */
    if (ultimateCfg()) {
      var ultHost = document.querySelector('.adirena-offer-selector');
      if (ultHost) {
        ultHost.insertAdjacentHTML('beforeend', buildUltimateHTML(CFG, CFG.shadeHeader || 'Shade'));
        ultimateFetchBundle();
        /* Resync du prix a CHAQUE changement de palier (le cablage generique met a jour la ligne
           d'offre, pas le bouton ni la barre collante quand `defaultOffer` n'est pas configure).
           Delegue + differe : on lit `currentOffer` APRES que selectOffer() l'ait mis a jour. */
        ultHost.addEventListener('click', function (e) {
          if (e.target.closest('.adirena-offer')) setTimeout(ultimateSyncPriceHosts, 80);
        });
        [document.querySelector('[data-add-to-cart-text]'), document.querySelector('.cart-bar')]
          .filter(Boolean)
          .forEach(function (host) {
            new MutationObserver(ultimateSyncPriceHosts)
              .observe(host, { childList: true, characterData: true, subtree: true });
          });
      }
    }

    var selector = document.querySelector('.adirena-offer-selector');
    if (!selector) return;
    var offers = selector.querySelectorAll('.adirena-offer');

    function selectOffer(offerNum) {
      currentOffer = offerNum;
      offers.forEach(function (o) {
        o.classList.toggle('is-selected', o.dataset.offer === offerNum);
      });

      /* Always keep qty=1 — BOGO sends 2 items via form-submit hijack (not via qty) */
      document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
        input.value = 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      /* Lock displayed ATC price ($34.90 for both — Shopify auto-discount handles BOGO total) */
      var priceLabel = OFFER_PRICES[offerNum];
      document.querySelectorAll('[data-add-to-cart-text] [data-product-price]').forEach(function (el) {
        el.textContent = priceLabel;
        el.dataset.adirenaLockedPrice = priceLabel;
      });

      /* Barre d'achat collante (2026-08-12, Codex MAJOR) : `.cart-bar` rend son PROPRE
         [data-product-price] HORS de [data-add-to-cart-text]. Un changement d'offre ne mute
         rien a l'interieur de la barre, donc l'observateur pose plus bas ne se reveille jamais
         et elle garde le prix de l'offre PRECEDENTE (repro : B2G3 pre-coche a $39.94, clic sur
         BOGO, la barre reste a $39.94 alors que le panier part a $19.97). On la resynchronise
         donc ICI, synchroniquement, sur la meme source (OFFER_PRICES) que le bouton principal. */
      if (priceLabel) {
        document.querySelectorAll('.cart-bar [data-product-price]').forEach(function (el) {
          el.textContent = priceLabel;
          el.dataset.adirenaLockedPrice = priceLabel;
        });
      }
    }

    /* Re-lock the ATC price if Palo Alto's subscription/qty updater overwrites it */
    var observerTarget = document.querySelector('[data-add-to-cart-text]');
    if (observerTarget) {
      var mo = new MutationObserver(function () {
        var priceEl = observerTarget.querySelector('[data-product-price]');
        if (priceEl && priceEl.dataset.adirenaLockedPrice && priceEl.textContent !== priceEl.dataset.adirenaLockedPrice) {
          priceEl.textContent = priceEl.dataset.adirenaLockedPrice;
        }
      });
      mo.observe(observerTarget, { childList: true, characterData: true, subtree: true });
    }

    offers.forEach(function (offer) {
      offer.addEventListener('click', function (e) {
        e.preventDefault();
        selectOffer(offer.dataset.offer);
      });
    });

    /* Pill selection — wire each pill to update its row's shade + caption + selected state */
    selector.querySelectorAll('.adirena-offer__pill-row').forEach(function (row) {
      var caption = row.querySelector('.adirena-offer__pill-caption');
      row.querySelectorAll('.adirena-offer__pill').forEach(function (pill) {
        pill.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var value = pill.dataset.shadeValue;
          row.dataset.shadeSelected = value;
          row.querySelectorAll('.adirena-offer__pill').forEach(function (p) {
            var isSel = p === pill;
            p.classList.toggle('is-selected', isSel);
            p.setAttribute('aria-checked', isSel ? 'true' : 'false');
          });
          if (caption) caption.textContent = value;
        });
      });
    });

    /* Pastilles de TAILLE — une rangee par unite, injectees dans les paliers, donc cablees a
       part (design D). No-op sans `sizes` : aucun bloc `[data-adirena-size]` n'existe. */
    wireSizeRows();
    injectUnitSoleRows();

    /* Hijack form submit for BOTH single and BOGO — POST items with shades from our selector */
    var productForm = document.querySelector('form[action*="/cart/add"]');
    /* Le chemin d'achat est-il reellement intercepte ? (branche maintenant OU deja branche
       sur un appel precedent). Conditionne le flag `adirena-offer-ready` en fin de fonction. */
    var buyPathWired = !!(productForm && productForm.dataset.adirenaBogoHooked === '1');
    if (productForm && productForm.dataset.adirenaBogoHooked !== '1') {
      productForm.dataset.adirenaBogoHooked = '1';
      buyPathWired = true;
      productForm.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var items;
        var b2g3Items = (currentOffer === 'b2g3') ? buildB2G3Items() : null;
        if (CFG.type === 'single') {
          /* single-SKU mask: BOGO sends 2× the one variant (BxGy discount frees the 2nd) */
          items = [{ id: CFG.variantId, quantity: currentOffer === 'bogo' ? 2 : 1 }];
        } else if (currentOffer === 'bogo') {
          var shade1Row = document.querySelector('[data-bogo-shade="1"]');
          var shade2Row = document.querySelector('[data-bogo-shade="2"]');
          var id1 = VARIANT_IDS[(shade1Row && shade1Row.dataset.shadeSelected) || DEFAULT_SHADE];
          var id2 = VARIANT_IDS[(shade2Row && shade2Row.dataset.shadeSelected) || DEFAULT_SHADE];
          items = [{ id: id1, quantity: 1 }, { id: id2, quantity: 1 }];
        } else {
          /* shaded single mode: 1 item with shade picked in Buy 1 pill row */
          var singleRow = document.querySelector('[data-single-shade]');
          var singleId = VARIANT_IDS[(singleRow && singleRow.dataset.shadeSelected) || DEFAULT_SHADE];
          items = [{ id: singleId, quantity: 1 }];
        }
        /* Surcharge B2G3 — posée APRÈS la chaîne existante pour ne modifier aucune de ses lignes
           (gate additive-only sur ce fichier partagé). Nulle si l'offre choisie n'est pas b2g3. */
        if (b2g3Items && b2g3Items.length) items = b2g3Items;

        /* Surcharge ULTIMATE — posee APRES la chaine existante (diff additif). Le palier remplace
           integralement les lignes : UNE variante du produit bundle, quantite 1, aucune remise.
           FAIL CLOSED (Codex BLOCKER 2) : si le bundle n'est pas pret ou si la combinaison de
           teintes ne resout aucun SKU connu, on ABANDONNE l'ajout au panier — jamais de repli sur
           une autre variante, qui ferait payer $39.97 pour le mauvais contenu (ou l'inverse). */
        if (currentOffer === 'ultimate') {
          var ultItems = buildUltimateItems();
          if (!ultItems) {
            console.error('[Adirena ultimate] resolution impossible — ajout panier abandonne');
            ULT.failed = true;
            ultimateSyncUI();
            return;
          }
          items = ultItems;
        }

        /* Surcharge TAILLE (design C, 2026-09-02) — posee APRES la chaine existante (diff
           additif). Sur un produit a deux options, les branches ci-dessus ont indexe
           VARIANT_IDS[coloris] et recupere un OBJET de pointures, pas un id : on re-derive donc
           integralement les lignes ici, depuis les rangees de coloris + la taille globale.
           FAIL CLOSED si la pointure manque ou si la combinaison coloris x pointure n'existe
           pas -> on abandonne l'ajout au lieu de poster un id absent. */
        if (SIZES.length && currentOffer !== 'ultimate') {
          var sizedItems = buildSizedItems();
          if (!sizedItems) {
            flagSizeRequired();
            console.error('[Adirena size] pointure non resolue — ajout panier abandonne');
            return;
          }
          items = sizedItems;
        }

        /* Marqueur d'intention d'offre — B2G3 UNIQUEMENT.
           Pourquoi : sans lui, une cliente qui choisit « payer 2, recevoir 5 » mais dont le
           panier n'envoie que 4 unités paie le même $39.94 et repart équilibrée (2 payées +
           2 offertes) — le détecteur de clientes lésées ne peut PAS la distinguer d'un achat
           volontaire de 4. Le marqueur rend l'intention lisible dans la commande.
           Vérifié le 2026-08-03 : la propriété survit au split de la remise (les 2 lignes la
           portent) et n'est affichée ni par UpCart ni par le thème natif (préfixe `_`).
           ⛔ On ne marque JAMAIS `single` ni `bogo` (gate Codex) : le BOGO est déjà couvert
           sans intention par l'invariant « payées > offertes », et un jour quelqu'un lirait
           `_offer: single` comme un opt-out du BOGO — régression support garantie. */
        if (b2g3Items && b2g3Items.length) {
          items.forEach(function (it) {
            it.properties = Object.assign({}, it.properties, { _offer: 'b2g3' });
          });
        }

        /* Optional product-truth line for carts that render visible line-item properties.
           Config-driven so shared runtime behavior stays unchanged for every other product. */
        if (CFG.cartIncludes) {
          items.forEach(function (it) {
            it.properties = Object.assign({}, it.properties, { Includes: CFG.cartIncludes });
          });
        }

        /* POST /cart/add.js with sections=header to get back fresh rendered header
           (which includes the <cart-element> drawer). Then replace the drawer DOM
           — the cart-element custom element will re-init via connectedCallback. */
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items, sections: 'header' })
        })
        .then(function (r) {
          if (!r.ok) {
            return r.text().then(function (t) { throw new Error('Cart add failed: ' + r.status + ' — ' + t); });
          }
          return r.json();
        })
        .then(function (data) {
          /* UpCart installé → il possède le tiroir (le #cart-drawer natif n'existe plus).
             On lui passe la main : refresh depuis /cart.js, il s'ouvre seul si "Open cart
             drawer on add to cart" = ON. Requiert "Enhanced Ajax API Compatibility" = ON. */
          if (typeof window.upcartRefreshCart === 'function') {
            window.upcartRefreshCart();
            return;
          }
          /* Replace <cart-element> with freshly rendered version (contains new items) */
          if (data && data.sections && data.sections.header) {
            try {
              var parser = new DOMParser();
              var doc = parser.parseFromString(data.sections.header, 'text/html');
              var newDrawer = doc.querySelector('#cart-drawer');
              var currentDrawer = document.querySelector('#cart-drawer');
              if (newDrawer && currentDrawer && currentDrawer.parentNode) {
                currentDrawer.parentNode.replaceChild(newDrawer, currentDrawer);
              }
              /* Also refresh cart count badge in header if present */
              var newBadge = doc.querySelector('[data-cart-icon-bubble], .cart-count, [data-cart-count]');
              var oldBadge = document.querySelector('[data-cart-icon-bubble], .cart-count, [data-cart-count]');
              if (newBadge && oldBadge && oldBadge.parentNode) {
                oldBadge.parentNode.replaceChild(newBadge.cloneNode(true), oldBadge);
              }
            } catch (replaceErr) {
              console.warn('[Adirena] Cart DOM replace failed:', replaceErr);
            }
          }
          /* Open the drawer */
          setTimeout(function () {
            var trigger = document.querySelector('[data-cart-drawer-toggle]');
            if (trigger) trigger.click();
          }, 50);
        })
        .catch(function (err) {
          console.error('[Adirena cart hijack]', err);
          window.location.href = '/cart';
        });
      }, true); /* capture phase to beat Palo Alto's own handler */
    }

    /* Price: read sync from DOM first (no flash), confirm async via product .js fetch */
    var domCents = readDOMPriceCents();
    if (domCents) applyDynamicPrices(domCents);
    fetchVariantPriceCents().then(function (cents) {
      if (cents) applyDynamicPrices(cents);
    });

    /* Default selection = BOGO (sauf noBogo : le palier n'existe pas, on reste sur single) */
    selectOffer(CFG.noBogo ? 'single' : 'bogo');

    /* === TEST 2026-08-12 — offre PRÉ-COCHÉE pilotée par config (`defaultOffer`) ===
       Additif : la ligne ci-dessus n'est pas touchée. Sans la clé, rien ne change (BOGO).
       Avec la clé, on re-sélectionne par-dessus, uniquement si la ligne existe vraiment dans
       le sélecteur rendu (un `defaultOffer: 'b2g3'` sans `b2g3: true` ne casse donc rien). */
    if (CFG.defaultOffer && selector.querySelector('[data-offer="' + CFG.defaultOffer + '"]')) {
      /* Garde-fou (Codex MINOR 4) : si le prix DOM est illisible ET que le fetch échoue, la
         clé de l'offre pré-cochée n'existe pas encore dans OFFER_PRICES et on écrirait
         littéralement « undefined » dans le prix. Placeholder neutre, générique. */
      if (!OFFER_PRICES[CFG.defaultOffer]) OFFER_PRICES[CFG.defaultOffer] = '$--.--';
      selectOffer(CFG.defaultOffer);
      /* Filet prix — DEUX surfaces, pas une.
         (a) Bouton ATC principal : `applyDynamicPrices()` re-verrouille ce prix sur le montant
             "single" quand le fetch prix ASYNCHRONE retombe, sans regarder l'offre sélectionnée.
             Invisible jusqu'ici parce que single et BOGO affichent le MÊME montant ; faux dès
             qu'une offre d'un autre montant est pré-cochée.
         (b) Barre d'achat collante (`.cart-bar`, activée sur cette PDP) : elle rend son PROPRE
             [data-product-price] HORS de [data-add-to-cart-text], donc ni selectOffer() ni
             l'observateur existant ne l'ont jamais touchée. Sans ce filet, la cliente lit
             $19.97 dans la barre collante et le panier part à $39.94 (Codex BLOCKER 2, vérifié :
             `cart-bar.liquid` a bien son propre élément prix, et le CSS `.adirena-offer-mode`
             ne masque que `.product__price-and-badge`, pas la barre).
         Chaque hôte est resynchronisé à chaque divergence. Convergent (dès que les deux valeurs
         coïncident plus personne n'écrit) donc pas de boucle avec l'observateur existant. */
      [document.querySelector('[data-add-to-cart-text]'), document.querySelector('.cart-bar')]
        .filter(Boolean)
        .forEach(function (host) {
          function syncOfferPrice() {
            var want = OFFER_PRICES[currentOffer];
            var priceEl = host.querySelector('[data-product-price]');
            if (want && priceEl && priceEl.dataset.adirenaLockedPrice !== want) {
              priceEl.dataset.adirenaLockedPrice = want;
              priceEl.textContent = want;
            }
          }
          syncOfferPrice();
          new MutationObserver(syncOfferPrice)
            .observe(host, { childList: true, characterData: true, subtree: true });
        });
    }

    /* FILET DE DISPONIBILITE (2026-08-01, Codex BLOCKER P1) — poser le flag ICI et nulle part
       ailleurs : head.liquid masque le prix + le picker NATIFS des le serveur (anti-flash), et un
       watchdog inline les rend si ce flag n'apparait pas. Le poser des que le SELECTEUR existe
       laissait passer un montage PARTIEL (formulaire non trouve, submit non hijacke) : natif
       masque + UI a moitie morte. On ne l'annonce donc qu'apres selectOffer ET seulement si le
       chemin d'achat est reellement intercepte. Sinon on laisse le filet rendre le natif. */
    if (buyPathWired) { document.documentElement.classList.add('adirena-offer-ready'); }
  }

  /* ===================================================================
     Shade Finder Quiz — Adirena (selfie theater + face brancher).
     The photo is theatrical only; the face question decides the shade.
     =================================================================== */
  /* Config-driven: cards = per-product map (head.liquid global), face→shade = CFG.quiz.faceShades */
  var QUIZ_HANDLE = (location.pathname.match(/\/products\/([^/?]+)/) || [])[1] || '';
  var QUIZ_CARDS = (window.ADIRENA_QUIZ_CARDS || {})[QUIZ_HANDLE] || {};
  /* Per-handle faces override (Thomas 2026-07-27, KBB fair->light-tan) ; fallback = set global inchangé */
  var QUIZ_FACES_OVERRIDE = (window.ADIRENA_QUIZ_FACES_MAP || {})[QUIZ_HANDLE];
  var QUIZ_FACES = (QUIZ_FACES_OVERRIDE && QUIZ_FACES_OVERRIDE.length === 6) ? QUIZ_FACES_OVERRIDE
    : (window.ADIRENA_QUIZ_FACES && window.ADIRENA_QUIZ_FACES.length === 6) ? window.ADIRENA_QUIZ_FACES : [];
  var FACE_SHADE = (CFG && CFG.quiz && CFG.quiz.faceShades) || [];
  var QUIZ = { shade: null, stream: null };

  function quizFacesHTML() {
    return QUIZ_FACES.map(function (url, i) {
      return '<button type="button" class="adirena-quiz__face" data-face="' + i + '">' +
               '<img src="' + url + '" alt="Skin tone ' + (i + 1) + '" loading="lazy">' +
             '</button>';
    }).join('');
  }
  function buildQuizModalHTML() {
    return '<div class="adirena-quiz" data-adirena-quiz hidden>' +
      '<div class="adirena-quiz__backdrop" data-quiz-close></div>' +
      '<div class="adirena-quiz__dialog" role="dialog" aria-modal="true" aria-label="Find your shade">' +
        '<button type="button" class="adirena-quiz__x" data-quiz-close aria-label="Close">&times;</button>' +
        '<div class="adirena-quiz__step is-active" data-step="intro">' +
          '<h3 class="adirena-quiz__title">Snap a quick selfie so we can match your perfect shade</h3>' +
          '<div class="adirena-quiz__cta-row adirena-quiz__cta-row--intro">' +
            '<button type="button" class="adirena-quiz__btn adirena-quiz__btn--ghost" data-quiz-upload>Upload photo</button>' +
            '<button type="button" class="adirena-quiz__btn adirena-quiz__btn--dark" data-quiz-selfie>Take selfie</button>' +
          '</div>' +
          '<button type="button" class="adirena-quiz__skip" data-quiz-skip>Skip</button>' +
          '<input type="file" accept="image/*" capture="user" hidden data-quiz-file>' +
        '</div>' +
        '<div class="adirena-quiz__step" data-step="camera">' +
          '<h3 class="adirena-quiz__title">Center your face</h3>' +
          '<div class="adirena-quiz__cam"><video data-quiz-video playsinline muted></video><span class="adirena-quiz__cam-ring"></span></div>' +
          '<div class="adirena-quiz__cta-row">' +
            '<button type="button" class="adirena-quiz__btn adirena-quiz__btn--ghost" data-quiz-cam-back>Back</button>' +
            '<button type="button" class="adirena-quiz__btn adirena-quiz__btn--dark" data-quiz-capture>Capture</button>' +
          '</div>' +
        '</div>' +
        '<div class="adirena-quiz__step" data-step="photo">' +
          '<h3 class="adirena-quiz__title">Thanks — our AI is analyzing your skin…</h3>' +
          '<img class="adirena-quiz__photo" data-quiz-photo alt="Your photo">' +
          '<div class="adirena-quiz__cta-row">' +
            '<button type="button" class="adirena-quiz__btn adirena-quiz__btn--ghost" data-quiz-retry>Retry</button>' +
            '<button type="button" class="adirena-quiz__btn adirena-quiz__btn--dark" data-quiz-go>Let’s go</button>' +
          '</div>' +
        '</div>' +
        '<div class="adirena-quiz__step" data-step="tone">' +
          '<h3 class="adirena-quiz__title">Which skin tone is closest to yours?</h3>' +
          '<p class="adirena-quiz__sub">Tap the one nearest your skin.</p>' +
          '<div class="adirena-quiz__faces">' + quizFacesHTML() + '</div>' +
        '</div>' +
        '<div class="adirena-quiz__step" data-step="loading">' +
          '<div class="adirena-quiz__spinner"></div>' +
          '<h3 class="adirena-quiz__title">Our AI is finding your perfect shade…</h3>' +
          '<p class="adirena-quiz__sub" data-quiz-loadmsg>Analyzing your complexion…</p>' +
        '</div>' +
        '<div class="adirena-quiz__step" data-step="result">' +
          '<h3 class="adirena-quiz__title">Your shade match is..</h3>' +
          '<img class="adirena-quiz__card" data-quiz-card alt="Your shade match">' +
          '<button type="button" class="adirena-quiz__btn adirena-quiz__btn--dark adirena-quiz__apply" data-quiz-apply>Shop my shade</button>' +
          '<button type="button" class="adirena-quiz__skip" data-quiz-retake>Retake</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function quizEl() { return document.querySelector('[data-adirena-quiz]'); }
  function quizShowStep(name) {
    var q = quizEl(); if (!q) return;
    q.querySelectorAll('.adirena-quiz__step').forEach(function (s) {
      s.classList.toggle('is-active', s.dataset.step === name);
    });
  }
  function stopQuizCamera() {
    if (QUIZ.stream) { QUIZ.stream.getTracks().forEach(function (t) { t.stop(); }); QUIZ.stream = null; }
  }
  function openQuiz() {
    var q = quizEl(); if (!q) return;
    QUIZ.shade = null;
    quizShowStep('intro');
    q.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  }
  function closeQuiz() {
    var q = quizEl(); if (!q) return;
    stopQuizCamera();
    q.hidden = true;
    document.documentElement.style.overflow = '';
  }
  function triggerQuizUpload() { var f = quizEl().querySelector('[data-quiz-file]'); if (f) f.click(); }
  function startQuizCamera() {
    var q = quizEl(); var video = q.querySelector('[data-quiz-video]');
    quizShowStep('camera');
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) { quizShowStep('intro'); triggerQuizUpload(); return; }
    navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user' }, audio: false })
      .then(function (stream) { QUIZ.stream = stream; video.srcObject = stream; var p = video.play(); if (p && p.catch) p.catch(function () {}); })
      .catch(function () { quizShowStep('intro'); triggerQuizUpload(); });
  }
  function showQuizPhoto(url) {
    var img = quizEl().querySelector('[data-quiz-photo]'); if (img) img.src = url;
    quizShowStep('photo');
  }
  function captureQuizPhoto() {
    var video = quizEl().querySelector('[data-quiz-video]');
    var w = video.videoWidth || 640, h = video.videoHeight || 640, s = Math.min(w, h);
    var canvas = document.createElement('canvas'); canvas.width = s; canvas.height = s;
    var ctx = canvas.getContext('2d');
    ctx.save(); ctx.translate(s, 0); ctx.scale(-1, 1);
    ctx.drawImage(video, (w - s) / 2, (h - s) / 2, s, s, 0, 0, s, s);
    ctx.restore();
    var url = canvas.toDataURL('image/jpeg', 0.9);
    stopQuizCamera();
    showQuizPhoto(url);
  }
  var QUIZ_LOAD_MSGS = ['Analyzing your complexion…', 'Reading your undertone…', 'Matching your perfect shade…'];
  function runQuizLoading() {
    quizShowStep('loading');
    var el = quizEl().querySelector('[data-quiz-loadmsg]'); var i = 0;
    var iv = setInterval(function () { i++; if (el && QUIZ_LOAD_MSGS[i]) el.textContent = QUIZ_LOAD_MSGS[i]; }, 700);
    setTimeout(function () { clearInterval(iv); showQuizResult(); }, 2100);
  }
  function showQuizResult() {
    var shade = QUIZ.shade || DEFAULT_SHADE;
    var img = quizEl().querySelector('[data-quiz-card]'); if (img) { img.src = QUIZ_CARDS[shade] || ''; img.alt = 'Your shade match — ' + shade; }
    var apply = quizEl().querySelector('[data-quiz-apply]'); if (apply) apply.textContent = 'Shop ' + shade + ' →';
    quizShowStep('result');
  }
  function selectShadeInBuyBox(shade) {
    document.querySelectorAll('.adirena-offer__pill-row').forEach(function (row) {
      var pill = row.querySelector('.adirena-offer__pill[data-shade-value="' + shade + '"]');
      if (pill && !pill.classList.contains('is-selected')) pill.click();
    });
  }
  function wireQuiz() {
    var q = quizEl(); if (!q) return;
    q.querySelectorAll('[data-quiz-close]').forEach(function (el) { el.addEventListener('click', closeQuiz); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && q && !q.hidden) closeQuiz(); });
    q.querySelector('[data-quiz-selfie]').addEventListener('click', startQuizCamera);
    q.querySelector('[data-quiz-upload]').addEventListener('click', triggerQuizUpload);
    q.querySelector('[data-quiz-skip]').addEventListener('click', function () { quizShowStep('tone'); });
    q.querySelector('[data-quiz-cam-back]').addEventListener('click', function () { stopQuizCamera(); quizShowStep('intro'); });
    q.querySelector('[data-quiz-capture]').addEventListener('click', captureQuizPhoto);
    q.querySelector('[data-quiz-retry]').addEventListener('click', function () { quizShowStep('intro'); });
    q.querySelector('[data-quiz-go]').addEventListener('click', function () { quizShowStep('tone'); });
    q.querySelector('[data-quiz-retake]').addEventListener('click', function () { QUIZ.shade = null; quizShowStep('intro'); });
    var file = q.querySelector('[data-quiz-file]');
    if (file) file.addEventListener('change', function () {
      var f = file.files && file.files[0]; if (!f) return;
      var reader = new FileReader();
      reader.onload = function (ev) { showQuizPhoto(ev.target.result); };
      reader.readAsDataURL(f);
    });
    q.querySelectorAll('.adirena-quiz__face').forEach(function (face) {
      face.addEventListener('click', function () { QUIZ.shade = FACE_SHADE[+face.dataset.face] || DEFAULT_SHADE; runQuizLoading(); });
    });
    var apply = q.querySelector('[data-quiz-apply]');
    if (apply) apply.addEventListener('click', function () {
      if (QUIZ.shade) selectShadeInBuyBox(QUIZ.shade);
      closeQuiz();
      var sel = document.querySelector('.adirena-offer-selector');
      if (sel) sel.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }
  function injectShadeQuiz() {
    if (!CFG || CFG.type !== 'shaded') return;  /* single-SKU = no quiz by design (no warning) */
    if (QUIZ_FACES.length !== 6 || FACE_SHADE.length !== 6 || !Object.keys(QUIZ_CARDS).length) {
      try { console.warn('[Adirena] "' + QUIZ_HANDLE + '" is shaded but the shade quiz is NOT rendering — missing: ' +
        (QUIZ_FACES.length !== 6 ? '6 tone-faces; ' : '') +
        (FACE_SHADE.length !== 6 ? 'quiz.faceShades(6) in JS; ' : '') +
        (!Object.keys(QUIZ_CARDS).length ? 'result-card map in head.liquid; ' : '')); } catch (e) {}
      return;
    }
    var selector = document.querySelector('.adirena-offer-selector');
    if (!selector) return;
    if (!document.querySelector('[data-quiz-open]')) {
      selector.insertAdjacentHTML('beforebegin',
        '<button type="button" class="adirena-quiz-trigger" data-quiz-open>' +
          '<span class="adirena-quiz-trigger__spark">✦</span> Not sure of your shade? <strong>Match my shade in 10s</strong>' +
        '</button>');
    }
    if (!document.querySelector('[data-adirena-quiz]')) {
      document.body.insertAdjacentHTML('beforeend', buildQuizModalHTML());
      wireQuiz();
    }
    document.querySelectorAll('[data-quiz-open]').forEach(function (btn) {
      if (btn.dataset.quizHooked === '1') return;
      btn.dataset.quizHooked = '1';
      btn.addEventListener('click', function (e) { e.preventDefault(); openQuiz(); });
    });
  }

  /* Ship-by window keyed by product handle (business days; default 2 below). Empty: every product uses the
     house default, as the other live PDPs do (Surya 2026-10-28, "fix it to unify like others live pdp";
     workos record surya-unify-ship-by-2026-10-28.md). */
  var DISPATCH_BUSINESS_DAYS = {};
  /* Ship-by counts CALENDAR days, weekends included (Surya 2026-10-30: "lets update the rules to be on 2 days, not
     2 business days, so this will includes the weekend"). Inserted, not edited: the business-day loop below stays
     byte-identical and is skipped while this is true; the window values above then count calendar days. */
  var DISPATCH_CALENDAR_DAYS = true;
  function dispatchBusinessDays(fallback) {
    var m = location.pathname.match(/\/products\/([^/?]+)/);
    return (m && DISPATCH_BUSINESS_DAYS[m[1]]) || fallback;
  }
  /* US-only delivery strip. Promise = two business days from the Chicago calendar date. */
  function getDispatchDate(now) {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Chicago', year: 'numeric', month: 'numeric', day: 'numeric'
    }).formatToParts(now || new Date());
    var values = {};
    parts.forEach(function (part) { if (part.type !== 'literal') values[part.type] = Number(part.value); });
    var cursor = new Date(Date.UTC(values.year, values.month - 1, values.day, 12));
    var remaining = 2;
    remaining = dispatchBusinessDays(remaining);
    if (DISPATCH_CALENDAR_DAYS) { cursor.setUTCDate(cursor.getUTCDate() + remaining); remaining = 0; }
    while (remaining > 0) {
      cursor.setUTCDate(cursor.getUTCDate() + 1);
      var weekday = cursor.getUTCDay();
      if (weekday !== 0 && weekday !== 6) remaining -= 1;
    }
    var day = cursor.getUTCDate();
    var suffix = day % 100 >= 11 && day % 100 <= 13 ? 'th' : ({1:'st',2:'nd',3:'rd'}[day % 10] || 'th');
    return new Intl.DateTimeFormat('en-US', {
      timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric'
    }).format(cursor) + suffix;
  }

  function dispatchHTML(displayDate) {
    return '<div class="adirena-dispatch" data-adirena-dispatch role="group" aria-label="Delivery">' +
      '<span class="adirena-dispatch__date"><span class="adirena-dispatch__dot" aria-hidden="true"></span>' +
        '<span>Ships by <strong data-adirena-dispatch-date>' + displayDate + '</strong></span></span>' +
      '<span class="adirena-dispatch__destination"><span aria-hidden="true">🇺🇸</span>' +
        '<span>Fast shipping to <strong>US</strong></span></span></div>';
  }

  function syncDispatch(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var inventories = [];
    if (scope.matches && scope.matches('[id^="Inventory-"]')) inventories.push(scope);
    Array.prototype.push.apply(inventories, scope.querySelectorAll('[id^="Inventory-"]'));
    var displayDate = getDispatchDate();
    inventories.forEach(function (inventory) {
      var strips = inventory.querySelectorAll('[data-adirena-dispatch]');
      var dateNode = strips.length === 1 ? strips[0].querySelector('[data-adirena-dispatch-date]') : null;
      var destination = strips.length === 1 ? strips[0].querySelector('.adirena-dispatch__destination') : null;
      if (dateNode && destination) {
        if (dateNode.textContent !== displayDate) dateNode.textContent = displayDate;
        return;
      }
      var template = document.createElement('template');
      template.innerHTML = dispatchHTML(displayDate);
      inventory.replaceChildren(template.content.cloneNode(true));
      inventory.dataset.adirenaDispatchInjected = '1';
      delete inventory.dataset.adirenaUrgencyInjected;
    });
  }

  /* MBG card : clean pink circle seal + heading + body */
  var MBG_CARD_HTML =
    '<div class="adirena-mbg-card-block">' +
      '<div class="adirena-mbg-card__top">' +
        '<svg class="adirena-mbg-card__seal" viewBox="0 0 80 80" aria-hidden="true">' +
          '<circle cx="40" cy="40" r="38" fill="none" stroke="#A85B58" stroke-width="1" stroke-dasharray="2 2"/>' +
          '<circle cx="40" cy="40" r="32" fill="#E8A4A0"/>' +
          '<text x="40" y="38" text-anchor="middle" fill="#FFFFFF" font-size="13" font-weight="800" font-family="DM Sans, sans-serif">100%</text>' +
          '<text x="40" y="52" text-anchor="middle" fill="#FFFFFF" font-size="7" font-weight="700" letter-spacing="1" font-family="DM Sans, sans-serif">GUARANTEE</text>' +
        '</svg>' +
        '<h4 class="adirena-mbg-card__title">30-day money-back guarantee</h4>' +
      '</div>' +
    '</div>';

  /* Sous-titre MBG par handle — entrée ADDITIVE keyed-handle (règle #2), demande Thomas 2026-10-27.
     Pas d'entrée pour un handle => carte rendue à l'octet près comme avant (MBG_CARD_HTML inchangé).
     Le CSS .adirena-mbg-card__body existe déjà (slot body prévu à la conception de la carte). */
  var MBG_SUBTITLES = {
    'cleo-cat-ear-hat': 'Try it worry-free. If Cleo isn’t as soft and warm as it looks, you’ll get your money back'
  };

  function mbgCardHTML() {
    var handle = (location.pathname.match(/\/products\/([^/?]+)/) || [])[1] || '';
    var subtitle = MBG_SUBTITLES[handle];
    if (!subtitle || MBG_CARD_HTML.lastIndexOf('</div></div>') === -1) return MBG_CARD_HTML;
    return MBG_CARD_HTML.slice(0, -'</div>'.length) +
      '<p class="adirena-mbg-card__body">' + subtitle + '</p></div>';
  }

  /* Per-text guarantee cards (additive, 2026-10-21): a buy box whose guarantee block carries its own
     promise keeps the house MBG card layout with that promise as the title. Kindred: Surya, relayed
     2026-10-21, "This = ☑ Made Right or Remade Free / Is the guarantee, so it should be in the
     guarantee box to replace the previous one". The text exists only on Kindred. */
  var GUARANTEE_CARD_TITLES = { 'Made Right or Remade Free': 'Made Right or Remade Free' };
  /* Cleo (cleo-cat-ear-hat), REVISIONS A3 2026-10-27: the Kindred / Littles card with the hat's money-back title, the
     copy pack's "Complete Satisfaction Promise" (approved by Surya; record: workos visuals/cat-ear-plush-hat/pdp-draft/
     REVISIONS-2026-10-27.md and the copy pack). The page's snippet adds the body line. Additive keyed entry; the text
     exists only on Cleo. */
  GUARANTEE_CARD_TITLES['Complete Satisfaction Promise'] = 'Complete Satisfaction Promise';

  function applyOverrides(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var textEls = scope.querySelectorAll('.product__icon__text');
    textEls.forEach(function (textEl) {
      var text = (textEl.textContent || '').trim();
      var block = textEl.closest('.product__block');
      if (!block || block.dataset.adirenaOverridden === '1') return;

      // Leave invalid source proof visible for the source/raw/computed gates to
      // reject. This is an injection opt-out, never concealment or replacement.
      if (NO_REVIEW_PROOF && (/others?\s+purchased|women\s+trust/i.test(text) ||
          (/review/i.test(text) && /4\.\d/.test(text)))) return;

      if (/others?\s+purchased|women\s+trust/i.test(text)) {
        block.innerHTML = AVATARS_HTML;
        block.classList.add('adirena-social-proof-block');
        block.dataset.adirenaOverridden = '1';
      } else if (/review/i.test(text) && /4\.\d/.test(text)) {
        block.innerHTML = STARS_HTML;
        block.classList.add('adirena-stars-block');
        block.dataset.adirenaOverridden = '1';
      } else if (/money[-\s]?back\s+guarantee/i.test(text) && block.dataset.adirenaMbgInjected !== '1') {
        /* Replace whole MBG block with custom card layout */
        block.innerHTML = mbgCardHTML();
        block.classList.add('adirena-mbg-block');
        block.dataset.adirenaMbgInjected = '1';
        block.dataset.adirenaOverridden = '1';
      }
      if (block.dataset.adirenaOverridden !== '1' && Object.prototype.hasOwnProperty.call(GUARANTEE_CARD_TITLES, text)) {
        block.innerHTML = MBG_CARD_HTML.replace('30-day money-back guarantee', GUARANTEE_CARD_TITLES[text]);
        block.classList.add('adirena-mbg-block');
        block.dataset.adirenaMbgInjected = '1';
        block.dataset.adirenaOverridden = '1';
      }
    });

    /* Replace Palo Alto inventory/scarcity copy with the shared US delivery strip. */
    syncDispatch(scope);

    injectOfferSelector(scope);
    injectShadeQuiz(scope);

    /* USP half-cards : add 16px margin-right on odd-indexed cards (left of each pair) */
    scope.querySelectorAll('.product__block--half').forEach(function (el, i) {
      el.style.marginRight = (i % 2 === 0) ? '16px' : '0';
    });
  }

  var dispatchSyncQueued = false;
  function queueDispatchSync() {
    if (dispatchSyncQueued) return;
    dispatchSyncQueued = true;
    window.requestAnimationFrame(function () {
      dispatchSyncQueued = false;
      syncDispatch(document);
    });
  }

  function inventoryMutation(record) {
    var target = record.target && record.target.nodeType === 1 ? record.target : record.target.parentElement;
    var inventory = target && target.closest ? target.closest('[id^="Inventory-"]') : null;
    if (inventory && !inventory.querySelector('[data-adirena-dispatch]')) return true;
    return Array.prototype.some.call(record.addedNodes, function (node) {
      return node.nodeType === 1 && ((node.matches && node.matches('[id^="Inventory-"]')) ||
        (node.querySelector && node.querySelector('[id^="Inventory-"]')));
    });
  }

  function bindDispatchObserver() {
    if (!document.body || document.body.dataset.adirenaDispatchObserved === '1') return;
    document.body.dataset.adirenaDispatchObserved = '1';
    new MutationObserver(function (records) {
      if (records.some(inventoryMutation)) queueDispatchSync();
    }).observe(document.body, { childList: true, subtree: true });
  }

  window.setInterval(function () { syncDispatch(document); }, 60000);
  window.addEventListener('pageshow', function () { syncDispatch(document); });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) syncDispatch(document);
  });

  /* === Cart drawer : "YOUR ORDER IS RESERVED FOR mm:ss" banner — 7 min, sessionStorage cached === */
  function getCartReservationEnd() {
    var stored = sessionStorage.getItem('adirena_cart_reservation');
    if (stored) {
      var ts = parseInt(stored, 10);
      if (ts > Date.now()) return ts;
    }
    var newEnd = Date.now() + 7 * 60 * 1000;
    sessionStorage.setItem('adirena_cart_reservation', String(newEnd));
    return newEnd;
  }
  function injectAndTickCartReservation() {
    var body = document.querySelector('[data-cart-drawer-body]');
    if (!body) return;
    var banner = body.querySelector('.adirena-cart-reservation');
    if (!banner) {
      body.insertAdjacentHTML('afterbegin',
        '<div class="adirena-cart-reservation"><span>YOUR ORDER IS RESERVED FOR <strong data-adirena-cart-countdown>--:--</strong></span></div>'
      );
      banner = body.querySelector('.adirena-cart-reservation');
    }
    var diff = getCartReservationEnd() - Date.now();
    if (diff < 0) { banner.style.display = 'none'; return; }
    var m = Math.floor(diff / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    banner.querySelector('[data-adirena-cart-countdown]').textContent =
      String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
  }
  setInterval(injectAndTickCartReservation, 1000);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { applyOverrides(); bindDispatchObserver(); });
  } else {
    applyOverrides();
    bindDispatchObserver();
  }

  /* Re-run on Shopify section reload (theme editor) and on variant changes */
  document.addEventListener('shopify:section:load', function (e) { applyOverrides(e.target); });
  document.addEventListener('shopify:block:select', function () { applyOverrides(); });

  /* WCH clean-handle bootstrap. The availability watchdog can run between the
     deferred asset load and DOMContentLoaded, before the product form exists.
     Retry once at window load so the canonical PDP mounts the same proven
     three-tier selector as GSE/VLB instead of falling back to the native picker. */
  window.addEventListener('load', function () {
    if (location.pathname === '/products/wired-cotton-headband' &&
        CFG && !document.querySelector('.adirena-offer-selector')) {
      document.documentElement.classList.add('adirena-offer-mode');
      applyOverrides(document);
    }
  });
})();

/* ============================================================
   Adirena — Scratch-card B1G1 popup  ->  REMOVED 2026-06-26.
   The email/SMS lead-capture popup is now managed by the Alia app
   (dashboard targeting), not custom code. Listicle exclusion lives in
   Alia's "Listicles — no popup" rule (Is on page(s) · contains /pages/).
   Orphaned CSS (.adirena-pop*) in adirena-overrides.css is inert (no DOM
   built) and can be stripped in a later cleanup pass.
   ============================================================ */

/* ============================================================
   Adirena — App-popup blackout on listicle pre-landers  2026-06-25
   theme.liquid sets window.__adirenaNoPopup when template.suffix contains
   'listicle' (already gates our own scratch popup). Third-party apps
   (Klaviyo onsite forms / Recart / Judge.me reviews popup) inject their
   popups by JS and bypass that gate. This module suppresses them, but ONLY
   on listicle pages (no legit Klaviyo/Recart/Judge.me embeds live there —
   header/footer are stripped). PDP/home are untouched.
   CSS hides on first paint; the JS sweep also overrides apps that set their
   own inline `display:...!important` and clears any body scroll-lock.
   ============================================================ */
(function () {
  'use strict';
  if (!window.__adirenaNoPopup) return;
  document.documentElement.classList.add('adirena-no-popup');
  var SEL = '.klaviyo-form,[class*="kl-private-reset-css"],[id*="klaviyo"],[id^="recart"],[class*="recart"],[id*="judgeme"],[class*="jdgm"]';
  function sweep() {
    try {
      var nodes = document.querySelectorAll(SEL), i;
      for (i = 0; i < nodes.length; i++) { nodes[i].style.setProperty('display', 'none', 'important'); }
      [document.documentElement, document.body].forEach(function (el) {
        if (el && el.style && el.style.overflow === 'hidden') { el.style.overflow = ''; }
      });
    } catch (e) {}
  }
  var pending = false;
  function schedule() {
    if (pending) return; pending = true;
    (window.requestAnimationFrame || window.setTimeout)(function () { pending = false; sweep(); });
  }
  sweep();
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', sweep); }
  window.addEventListener('load', sweep);
  try { new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
  /* late-firing app timers (Recart/Klaviyo delay-based popups) */
  [1000, 3000, 6000, 10000].forEach(function (t) { window.setTimeout(sweep, t); });
})();

/* Cosmetic labels only: keep option values and all cart/variant resolution intact. */
(function () {
  'use strict';
  function labelControls() {
    var host = document.querySelector('.adirena-offer-selector');
    if (!host) return null;
    host.querySelectorAll('.adirena-size__select option, .spr-size__select option').forEach(function (option) {
      var compact = option.textContent.replace(/^US Women\s+/, 'US ');
      if (compact !== option.textContent) option.textContent = compact;
    });
    host.querySelectorAll('[class$="-dd__btn"]').forEach(function (button) {
      var name = button.children[1];
      if (name) {
        var full = name.textContent.trim();
        if (button.getAttribute('aria-label') !== full) button.setAttribute('aria-label', full);
        if (button.title !== full) button.title = full;
      }
    });
    return host;
  }
  function start() {
    var host = labelControls();
    if (!host) return false;
    new MutationObserver(labelControls).observe(host, {childList:true,subtree:true});
    return true;
  }
  if (start()) return;
  var boot = new MutationObserver(function () { if (start()) boot.disconnect(); });
  boot.observe(document.documentElement, {childList:true,subtree:true});
})();
